import cx from 'classnames';
import { Link, useNavigate } from 'react-router-dom';
import { SETTINGS_ROUTE } from '../../config/constant/routePathConstant';
import constants, {
  IMAGINE_CREDIT_BASE_TYPE,
  MATTRESS_BUILDER_BASE_TYPE,
  SETTINGS_TAB,
  SUBSCRIPTION_MODEL_TYPE,
  TEXTURE_BASE_TYPE,
  THREE_3D_MODAL_BASE_TYPE,
  UNLIMITED_AI_GENERATION,
  UNLIMITED_RENDERING,
  UPLOAD_LIMIT_TYPE_LABEL,
  HIDE_ARROW_TYPES,
} from '../../constants/constants';
import PlanInfoActionCard from './PlanInfoActionCard';
import TitleAndLinkWrapper from './TitleAndLinkWrapper';
import Wrapper from './Wrapper';
import styles from './PurchasedPlan.module.scss';
import {
  selectAddonsList,
  selectAddOnSuccessFlag,
  selectAllPurchasedPlanListSelector,
  selectFreemiumProductsUsedCount,
  selectIsThreeDCardActive,
  selectPurchaseAddOns,
  selectPurchaseOneTimeAddOns,
  selectUserPlanList,
  subscriptionActions,
} from '../../redux/slicers/subscriptionSlicer';
import { useDispatch, useSelector } from 'react-redux';
import {
  ADD_ONS_PRODUCT_BASE_NAME,
  AddOnsTab,
  HIDE_BUY_MORE_FOR_SELF_SERVE_BASE_TYPE_LIST,
  PLAN_TYPE_TAB,
  PRODUCT_ID_TWO,
  RECURRING_INTERVAL,
  TEXTURE_PRODUCT_ID,
  TEXTURE_PRODUCT_NAME,
  THREE_D_MODEL_PRODUCT_NAME,
  THREE_D_MODEL_VARIATION_PRODUCT_NAME,
  UPLOAD_SUBSCRIPTION_TITLE_BASE_ON_BASE_TYPE,
  calculatePlanPrice,
  convertStripeCentsToAmount,
  getCurrentSubscriptionPlanMessage,
  getDateFromTimestamp,
  getPlanRecurringCycle,
  navigateToAddOns,
  navigateToBilling,
  navigateToProductUsageHistory,
  removeParamsFromUrl,
} from './subscriptionHelper';
import {
  AddAddonCart,
  GetAllCartProductList,
  GetPurchasedOnAddonsList,
  RemoveAddonsSubscriptionItem,
  RemoveAddonsSubscriptionItemV2,
  UpgradeToNewPlanPatchV2,
  apiGetAllProductUsedCount,
  apiToCancelOrRestoreActiveClientSubscription,
  apiToCancelOrRestoreActiveClientSubscriptionV2,
  removeAllItemsFromCart,
  setClientSubscriptionPlans,
  setClientSubscriptionPlansV2,
  setFailedClientSubscriptionPlansAndAddOnsV2,
  updateUploadLimitSubscription,
} from '../../api/subscription/subscription';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Loader from '../../components/Loader/Loader';
import { openInfoDialog, useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import { useUserContext } from '../../contexts/UserContext';
import { Card, Col, ProgressBar, Row, Tab, Table, Tabs } from 'react-bootstrap';
import format from 'date-fns/format';
import { usePermissionsHandler } from '../../hooks/usePermissions';
// import { warningToast } from '../../helpers/toastHelper';
import { selectPlanList } from '../../redux/slicers/subscriptionSlicer';
import { InfoIcon } from '../../components/icons/InfoIcon';
// import { CustomProducts } from './CustomProducts';
import { PERMISSION, PERMISSIONS } from '../../constants/permissionConstants';
// import titleStyles from './TitleAndLinkWrapper.module.scss';
import {
  EditPensilIcon,
  LeftArrowALT,
  // LeftArrowIcon,
  RightArrowALT,
  RightIcon,
  WarningInfoIcon,
} from '../../assets/icons';
import { BigButton, CircularProgress, ModalButtonArea } from '../../common';
import {
  SortArrayBySeq,
  formatNumber,
  getPercentValueFromCount,
  getPlanRecurringPeriod,
  openFormInCaseOfNewOrgAndFreemiumUser,
  progressSliderType,
  windowOpen,
} from '../../helpers/jsHelper';
import { dispatcher, navigate } from '../../helpers/projectHelper';
import Button from '../../components/Button';
import MinusIcon from '../../components/icons/MinusIcon';
import PlusIcon from '../../components/icons/PlusIcon';
import SubscriptionStatusModal from './SubscriptionStatusModal';
import DeleteIcon from '../../components/icons/DeleteIcon';
import { errorToast, successToast, warningToast } from '../../helpers/toastHelper';
import { ElipsisTooltip } from '../../common/ElipsisTooltip';
import ActionLink from './ActionLink';
import { ADMIN_SETTINGS, MY_PLANS_ROUTE, PRICING_ROUTE } from '../../constants/routePathConstants';
import { callTrackEvent } from '../../helpers/segmentHelper';
import useCurrentOrganizationInfo from '../../hooks/useCurrentOrganizationInfo';
import AddOnsInfoV2 from './AddOnsInfoV2';
import { userPilotEvents } from '../../common/Userpilot/userpilotHelper';
import useSubscriptionPurchase from '../../hooks/useSubscriptionPurchase';

export const PurchasedPlan = ({ userHaveNoPlan, setModifySubscription }) => {
  const { handlePermissionEvent } = usePermissionsHandler();
  const { handleRestorePlan = () => {} } = useSubscriptionPurchase({imagineCredit:true});
  const dispatch = useDispatch();
  const userPlans = useSelector(selectUserPlanList);
  const plans = useSelector(selectPlanList);
  // const purchaseAddOnsList = useSelector(selectPurchaseAddOns);
  const { isFreemiumUser , currentUser, isPremiumUser, isOldSubscriptionUser } = useUserContext();
  const activePlan = userPlans?.filter((a) => !a.is_cancelled)?.[0];
  const activePlanId = activePlan?.id;
  const activePlanName = activePlan?.plan_details?.[0]?.plan_name;
  const nonActivePlan = userPlans
    .filter((a) => a?.id !== activePlanId)
    .filter((a) => !a.is_cancelled);
  // const [loader, setLoader] = useState(false);
  const expiredPlanList = userPlans?.filter(
    ({ is_cancelled, status, is_add_on_subscription }) =>
      (is_cancelled === true || status === 'deleted') && !is_add_on_subscription
  );
  const [restoreLoading, setRestoreLoading] = useState(false);
  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();
  const [dataForSegmentLocal, setDataForSegmentLocal] = useState(null);
  const { isFreemiumOrSelfServeUser } = useCurrentOrganizationInfo();
  // useEffect(() => {
  //   if (!purchaseAddOnsList?.results?.length) {
  //     getAddonsSubscriptionList();
  //   }
  // }, []);

  // const getAddonsSubscriptionList = async () => {
  //   setLoader(true);
  //   await dispatch(GetPurchasedOnAddonsList());
  //   setLoader(false);
  // };

  const restoreCancelCurrentPlan = async () => {
    if (!activePlanId) return;
    setRestoreLoading(true);
    if (!activePlan?.is_upload_limit_plan) {
      const API = apiToCancelOrRestoreActiveClientSubscription;
      await API({
        id: activePlanId,
        cancel_at_period_end: false,
        successMessage: 'Your plan is successfully restored.',
      })
        .then(() => {})
        .finally(() => {
          closeInfoDialog();
          dispatch(setClientSubscriptionPlans());
          setRestoreLoading(false);
        });
    } else {
      await handleRestorePlan();
      setRestoreLoading(false);
    }
  };

  const handleRestoreCancelCurrentPlan = () => {
    handlePermissionEvent(
      PERMISSION.SUBSCRIPTION,
      (r) => {
        if (r === undefined) {
          restoreCancelCurrentPlan();
          // openInfoDialog({
          //   title: 'Restoring plan!',
          //   description: 'Your plan will continue from now.',
          //   cancelButtonText: "Don't restore",
          //   buttonText: isFreemiumOrSelfServeUser
          //     ? 'Restore Creator Plan'
          //     : `Restore ${activePlanName}`,
          //   onButtonClick: restoreCancelCurrentPlan,
          //   open: true,
          // });
        }
      },
      PERMISSIONS.SUBSCRIPTION.warningMessage
    )();
  };

  const downgradedPlanId = activePlan?.downgraded_plan_id;
  const downgradedPlanDetail = !downgradedPlanId
    ? null
    : plans
        .map((plan) => {
          const i = plan.pricing_details.findIndex(
            (price) => price.stripe_price_id === downgradedPlanId
          );
          if (i !== -1) {
            const detail = { ...plan.pricing_details?.[i] };
            detail['plan_name'] = `${plan?.name || detail.nickname} (${getPlanRecurringPeriod(
              detail
            )})`;
            return detail;
          }
          return false;
        })
        .filter(Boolean)?.[0];

  const orgSubscriptionStatus = currentUser?.organization_detail?.status?.name;
  const orgSubscriptionEndDate = currentUser?.organization_detail?.subscription_end_date;

  const showMissingPlanCard = isPremiumUser() && userHaveNoPlan;

  const showTab = {
    current: true,
    expired: expiredPlanList?.length ? true : false,
    downgradedPlan: downgradedPlanId ? true : false,
  };

  const handleFreemiumCase = () => {
    if (!activePlan && userHaveNoPlan) {
      const oldSubscriptionPlanName =
            currentUser?.organization_detail?.subscription_name || 'imagine.io';
      const planName = isFreemiumUser()
        ? 'Free'
        : isOldSubscriptionUser()
        ? oldSubscriptionPlanName
        : '';
      return {
        plan_name: planName,
        isCurrentPlan: true,
        description: getCurrentSubscriptionPlanMessage(currentUser),
        showBilling: false,
        isFreemium: isFreemiumUser(),
      };
    } else {
      return null;
    }
  }
  
  return (
    <Wrapper className="mb-0" style={{ border: 'none' }}>
      {showMissingPlanCard && (
        <MissingPlanDetails
          expiredPlanList={expiredPlanList}
          orgSubscriptionStatus={orgSubscriptionStatus}
          orgSubscriptionEndDate={orgSubscriptionEndDate}
          showTab={showTab}
          setModifySubscription={setModifySubscription}
        />
      )}

      {/* {downgradedPlanId && downgradedPlanDetail && (
        <PlanContainer
          key={downgradedPlanId}
          details={downgradedPlanDetail || {}}
          description={
            <>
              You will be downgraded to this plan on{' '}
              <strong>{getDateFromTimestamp(activePlan?.current_period_end_timestamp)}</strong>
            </>
          }
        />
      )} */}

      {/* {activePlan && (
        <PlanContainer
          key={activePlanId}
          details={activePlan?.plan_details?.[0] || {}}
          expiresOnTimestamp={activePlan?.current_period_end_timestamp}
          isActivePlan={activePlan?.is_active_main_subscription_plan}
          isCancelAtPeriodEnd={activePlan?.cancel_at_period_end}
          isCancelled={activePlan?.is_cancelled}
          includedAddOns={activePlan?.included_addons}
          isPlanDowngraded={downgradedPlanId}
          loading={restoreLoading}
          onClick={handleRestoreCancelCurrentPlan}
        />
      )} */}
      {!showMissingPlanCard &&
        (activePlan || nonActivePlan?.length > 0 || expiredPlanList?.length > 0) && (
          <>
            <CurrentPlanListContainerV2
              allPlanList={
                // downgradedPlanDetail
                //   ? [activePlan, ...nonActivePlan, ...expiredPlanList, downgradedPlanDetail]
                //   : [activePlan, ...nonActivePlan, ...expiredPlanList]
                // downgradedPlanDetail
                //   ? [activePlan, ...nonActivePlan, ...expiredPlanList, downgradedPlanDetail]
                [activePlan || handleFreemiumCase(), ...nonActivePlan, ...expiredPlanList]
              }
              key={activePlanId}
              details={activePlan?.plan_details?.[0] || {}}
              expiresOnTimestamp={activePlan?.current_period_end_timestamp}
              isActivePlan={
                (activePlan?.is_active_main_subscription_plan || activePlan?.is_upload_limit_plan) && !activePlan?.is_ai_imagine_subscription && !activePlan?.is_ai_imagine && !activePlan?.is_ai_imagine_one_time
              }
              isCancelAtPeriodEnd={activePlan?.cancel_at_period_end}
              isCancelled={activePlan?.is_cancelled}
              includedAddOns={activePlan?.included_addons}
              isPlanDowngraded={downgradedPlanId}
              downgradedPlanDetail={downgradedPlanDetail}
              loading={restoreLoading}
              onClick={handleRestoreCancelCurrentPlan}
              showTab={showTab}
              dataForSegment={dataForSegmentLocal}
              setModifySubscription={setModifySubscription}
            />
            <AvailableItemsContainerV2
              setModifySubscription={setModifySubscription}
              isActivePlan={
                (activePlan?.is_active_main_subscription_plan || activePlan?.is_upload_limit_plan) && !activePlan?.is_ai_imagine_subscription && !activePlan?.is_ai_imagine && !activePlan?.is_ai_imagine_one_time
              }
              isCancelAtPeriodEnd={activePlan?.cancel_at_period_end}
              loading={restoreLoading}
              planName={activePlan?.plan_details?.[0]?.plan_name || ''}
              updateSegmentData={(val) => setDataForSegmentLocal(val)}
            />
          </>
        )}
      {/* <AdditionalAddOns data={purchaseAddOnsList?.results || []} loader={loader} /> */}
      {/* {nonActivePlan?.length > 0 &&
        nonActivePlan.map((a) => (
          <PlanContainer
            key={a.id}
            details={a?.plan_details?.[0] || {}}
            expiresOnTimestamp={a.current_period_end_timestamp}
            isActivePlan={a.is_active_main_subscription_plan}
            isCancelAtPeriodEnd={a.cancel_at_period_end}
            isCancelled={a.is_cancelled}
            includedAddOns={a.included_addons}
          />
        ))} */}
      {/* <CustomProducts /> */}
      {/* {expiredPlanList?.length !== 0 && <ExpiredPlanList expiredPlanList={expiredPlanList} />} */}
    </Wrapper>
  );
};

const MissingPlanDetails = ({ orgSubscriptionStatus, orgSubscriptionEndDate = null, ...rest }) => {
  const plan_name = orgSubscriptionStatus ? `${orgSubscriptionStatus} plan` : 'imagine.io';
  if (!plan_name) return null;
  const parsedOrgSubscriptionEndDateTimestamp = orgSubscriptionEndDate
    ? Math.floor(new Date(orgSubscriptionEndDate).getTime() / 1000.0)
    : null;

  const [dataForSegmentLocal, setDataForSegmentLocal] = useState(null);
  const description = orgSubscriptionStatus
    ? parsedOrgSubscriptionEndDateTimestamp
      ? `This plan will renew on ${getDateFromTimestamp(
          parsedOrgSubscriptionEndDateTimestamp,
          true
        )}.`
      : ''
    : 'You are currently on the imagine.io subscription plan.';
  return (
    <>
      <CurrentPlanListContainerV2
        {...rest}
        details={{
          plan_name: plan_name,
        }}
        allPlanList={[
          {
            plan_name: plan_name,
            isCurrentPlan: true,
            description: description,
            showBilling: false,
          },
          ...rest?.expiredPlanList,
        ]}
        hidePrice
        isMissingPlan
        expiresOnTimestamp={parsedOrgSubscriptionEndDateTimestamp}
        description={description}
        dateOnlyForExpiresOn={true}
        showExpiryDateForMissingPlanDetails={true}
        dataForSegment={dataForSegmentLocal}
        setModifySubscription={rest?.setModifySubscription}
      />
      <AvailableItemsContainerV2
        planName={plan_name}
        updateSegmentData={(val) => setDataForSegmentLocal(val)}
        setModifySubscription={rest?.setModifySubscription}
      />
    </>
  );
};

export const FreemiumOrOldSubscriptionPlanContainer = (props) => {
  const dispatch = useDispatch();
  const { isFreemiumUser, isOldSubscriptionUser, currentUser } = useUserContext();
  const { isFreemiumOrSelfServeUser } = useCurrentOrganizationInfo();

  const freemiumProducts = useSelector(selectFreemiumProductsUsedCount);

  const [dataForSegmentLocal, setDataForSegmentLocal] = useState(null);

  const oldSubscriptionPlanName =
    currentUser?.organization_detail?.subscription_name || 'imagine.io';
  const planName = isFreemiumUser()
    ? 'Free'
    : isOldSubscriptionUser()
    ? oldSubscriptionPlanName
    : '';
  const description = getCurrentSubscriptionPlanMessage(currentUser);

  if (!planName || !description) return null;

  return (
    <>
      <CurrentPlanListContainerV2
        details={{
          plan_name: planName,
        }}
        showTab={{
          current: true,
        }}
        allPlanList={[
          {
            plan_name: planName,
            isCurrentPlan: true,
            description: description,
            showBilling: false,
            isFreemium: true,
          },
        ]}
        isFreemium
        hidePrice
        description={description}
        includedAddOns={freemiumProducts}
        upgradeButtonText={
          oldSubscriptionPlanName
            ? isFreemiumOrSelfServeUser
              ? 'Manage subscription'
              : 'Review plan'
            : 'Upgrade plan'
        }
        showUpgradeButton={true}
        showProductUsageHistoryButton={isFreemiumUser()}
        onClick={
          isFreemiumOrSelfServeUser
            ? () => navigate(MY_PLANS_ROUTE) // navigate(PRICING_ROUTE)
            : () => dispatch(subscriptionActions.setBrowsePlans(true))
        }
        doNotShowCombinedModel={true}
        dataForSegment={dataForSegmentLocal}
        setModifySubscription={props?.setModifySubscription}
      />
      <AvailableItemsContainerV2
        showProductUsageHistoryButton={isFreemiumUser()}
        planName={planName || ''}
        updateSegmentData={(val) => setDataForSegmentLocal(val)}
        setModifySubscription={props?.setModifySubscription}
      />
    </>
  );
};

export const PlanContainer = ({
  description: _description = '',
  details,
  expiresOnTimestamp = null,
  isActivePlan = false,
  isCancelAtPeriodEnd = false,
  isCancelled = false,
  showTooltip = true,
  includedAddOns = [],
  includedAddOnsTitle = 'Included in your plan',
  loading = false,
  onClick = () => {},
  upgradeButtonText = 'Upgrade plan',
  showUpgradeButton = false,
  showProductUsageHistoryButton = false,
  isPlanDowngraded = null,
  dateOnlyForExpiresOn = false,
  doNotShowCombinedModel = false,
  isManuallyProduct = false,
  includedAddOnsManually = [],
  showExpiryDateForMissingPlanDetails = false,
  setModifySubscription = () => {},
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isGuestUser, isOldSubscriptionUser } = useUserContext();
  const { isFreemiumOrSelfServeUser, hideNewPlans } = useCurrentOrganizationInfo();
  const { plan_name, recurring_interval_id, price_amount } = details;
  const expiresOn = getDateFromTimestamp(expiresOnTimestamp, dateOnlyForExpiresOn);
  const expiresOnDate = getDateFromTimestamp(expiresOnTimestamp, true);
  const nextBillingDate = getDateFromTimestamp(expiresOnTimestamp, true);
  const planPrice = convertStripeCentsToAmount(price_amount);

  const isPlanActiveAndNotCancel = isActivePlan && !isCancelAtPeriodEnd;
  const isPlanActiveAndCancel = isActivePlan && isCancelAtPeriodEnd;
  const isPlanNotActiveAndCancel = !isActivePlan && isCancelAtPeriodEnd;

  const description = isPlanActiveAndNotCancel
    ? `You are currently on a ${getPlanRecurringCycle(recurring_interval_id, true)} plan.`
    : isCancelAtPeriodEnd
    ? `This plan is scheduled to cancel.`
    : _description;

  let _includedAddOns = [...includedAddOns];
  let combined3dModelAddons = null;
  if (!doNotShowCombinedModel && _includedAddOns.length > 0) {
    let threeDModel = _includedAddOns.find(
      (a) =>
        a?.basemodeltype?.toLowerCase() === SUBSCRIPTION_MODEL_TYPE.THREE_D_MODEL?.toLowerCase()
    );
    let threeDModelVariation = _includedAddOns.find(
      (a) =>
        a?.basemodeltype?.toLowerCase() ===
        SUBSCRIPTION_MODEL_TYPE.THREE_D_MODEL_VARIATION?.toLowerCase()
    );
    _includedAddOns = _includedAddOns.filter(
      (a) =>
        a?.basemodeltype?.toLowerCase() !== SUBSCRIPTION_MODEL_TYPE.THREE_D_MODEL?.toLowerCase() &&
        a.basemodeltype?.toLowerCase() !==
          SUBSCRIPTION_MODEL_TYPE.THREE_D_MODEL_VARIATION?.toLowerCase()
    );

    let threeDModelForCalculate = { ...threeDModel };
    if (isManuallyProduct) {
      threeDModelForCalculate =
        includedAddOnsManually.find(
          (a) =>
            a?.basemodeltype?.toLowerCase() === SUBSCRIPTION_MODEL_TYPE.THREE_D_MODEL?.toLowerCase()
        ) || {};
    }

    if (threeDModel || threeDModelVariation) {
      combined3dModelAddons = {
        ...(threeDModel && {
          ...threeDModel,
          name: '3D Model',
        }),
        threeDV_name: '3D Model Variation',
        threeDV_total_count:
          (threeDModelForCalculate?.total_count || 0) * 2 +
          (threeDModelVariation?.total_count || 0),
        threeDV_used_count:
          (threeDModelForCalculate?.used_count || 0) * 2 + (threeDModelVariation?.used_count || 0),
        threeDV_available_count:
          (threeDModelForCalculate?.available_count || 0) * 2 +
          (threeDModelVariation?.available_count || 0),
      };
    }
  }

  return (
    <Wrapper className="mb-4">
      {loading && <Loader position="absolute" loading backdrop />}
      <TitleAndLinkWrapper
        title={
          <>
            {plan_name}{' '}
            {isActivePlan && isCancelAtPeriodEnd && (
              <label className="inline-tag" disabled>
                CANCEL ON {expiresOnDate}
              </label>
            )}
            {isCancelled && (
              <label className="inline-tag" disabled>
                CANCELLED
              </label>
            )}
          </>
        }
        description={description}
        cancelTag={
          <>
            {!isActivePlan && isCancelAtPeriodEnd && (
              <label className="inline-tag" disabled>
                Cancel At {expiresOnDate}
              </label>
            )}
          </>
        }
        style={{
          borderLeftStyle: 'none',
          borderRightStyle: 'none',
          borderTopStyle: 'none',
          borderRadius: 0,
        }}
        {...(isPlanActiveAndNotCancel && isOldSubscriptionUser() && {
          buttonText: isFreemiumOrSelfServeUser && !isOldSubscriptionUser() ? 'Manage Subscription' : 'Review plan',
          onClick: isFreemiumOrSelfServeUser
            ? () => navigate(MY_PLANS_ROUTE) // navigate(PRICING_ROUTE)
            : () => dispatch(subscriptionActions.setBrowsePlans(true)),
        })}
        {...(isPlanActiveAndCancel && {
          buttonText: 'Restore plan',
          onClick: onClick,
        })}
        {...(showUpgradeButton && {
          buttonText: upgradeButtonText,
          onClick: onClick,
        })}
        {...((showProductUsageHistoryButton || isFreemiumOrSelfServeUser) && {
          productUsageViewTitle: 'View usage history',
          productUsageViewbuttonClick: navigateToProductUsageHistory,
        })}
        {...((isPlanActiveAndNotCancel || isFreemiumOrSelfServeUser) &&
          !isGuestUser() &&
          !hideNewPlans && {
            buttonTitle: 'View add-ons',
            buttonClick: isFreemiumOrSelfServeUser
              ? () => setModifySubscription?.(true)
              : navigateToAddOns,
          })}
      />

      {(_includedAddOns.length !== 0 || combined3dModelAddons) && (
        <Wrapper
          title={includedAddOnsTitle}
          showTooltip={
            showTooltip && {
              icon: InfoIcon,
              message: 'Your plan might include one-time items from before.',
            }
          }
          // description={getPlanRecurringCycle(recurring_interval_id) ? `(per ${getPlanRecurringCycle(recurring_interval_id)})` : ""}
          className="p-4"
          childrenClassName={'gap-3'}
          {...((isPlanActiveAndNotCancel || isFreemiumOrSelfServeUser) &&
            !hideNewPlans && {
              buttonTitle: 'View add-ons',
              buttonClick: isFreemiumOrSelfServeUser
                ? () => setModifySubscription?.(true)
                : navigateToAddOns,
            })}
          {...((isPlanActiveAndNotCancel || isFreemiumOrSelfServeUser) && {
            productUsageViewTitle: 'View usage history',
            productUsageViewbuttonClick: navigateToProductUsageHistory,
          })}
          style={{
            background: '#fff',
            border: 'none',
            borderBottom: '1px solid #e8e8e8',
            borderRadius: 0,
          }}>
          {combined3dModelAddons && (
            <PlanInfoActionCard
              split={true}
              {...(combined3dModelAddons.total_count !== 0 && {
                title: combined3dModelAddons.name,
                description: `${combined3dModelAddons.available_count}/${combined3dModelAddons.total_count}`,
              })}
              {...(combined3dModelAddons.threeDV_total_count !== 0 && {
                title2: combined3dModelAddons.threeDV_name,
                description2: `${combined3dModelAddons.threeDV_available_count}/${combined3dModelAddons.threeDV_total_count}`,
              })}
            />
          )}
          {_includedAddOns.map((a, i) => (
            <PlanInfoActionCard
              key={i}
              title={a.name}
              description={`${a.available_count}/${a.total_count}`}
            />
          ))}
        </Wrapper>
      )}

      {(expiresOn || isPlanActiveAndNotCancel) && (
        <Wrapper
          className="p-4"
          childrenClassName={'gap-3'}
          style={{
            background: '#fff',
            border: 'none',
          }}>
          {(showExpiryDateForMissingPlanDetails ||
            isPlanActiveAndCancel ||
            isPlanNotActiveAndCancel ||
            isPlanDowngraded) &&
            expiresOn && <PlanInfoActionCard title="Expires on" description={expiresOn} />}
          {isPlanActiveAndNotCancel && !isPlanDowngraded && (
            <PlanInfoActionCard
              title="Next billing date"
              description={nextBillingDate + ' for USD ' + planPrice}
              actionText="Go to billing"
              onClick={() => navigate(`${SETTINGS_ROUTE}?activeTab=${SETTINGS_TAB.BILLING}`)}
            />
          )}
        </Wrapper>
      )}
    </Wrapper>
  );
};

export const AdditionalAddOns = ({ data, loader = false }) => {
  const purchaseOneTimeAddOnsList = useSelector(selectPurchaseOneTimeAddOns);
  const [tab, setTab] = useState(AddOnsTab?.RECURRING_ADD_ONS);
  const [oneTimeAddOns, setOneTimeAddOns] = useState([]);
  const hide = oneTimeAddOns?.length + data?.length;

  const handleTabChange = (key) => {
    setTab(+key);
  };

  useEffect(() => {
    if (data && !data?.length) {
      setTab(AddOnsTab?.ONE_TIME_ADD_ONS);
    } else {
      setTab(AddOnsTab?.RECURRING_ADD_ONS);
    }
  }, [data]);

  useEffect(() => {
    if (purchaseOneTimeAddOnsList?.results?.length) {
      setOneTimeAddOns(
        purchaseOneTimeAddOnsList?.results?.filter(({ subscription_id }) => !subscription_id) || []
      );
    }
  }, [purchaseOneTimeAddOnsList?.results]);

  const handlePurchasedAddonsLengthCount = (value, type) => {
    let sum = 0;
    if (type == AddOnsTab?.RECURRING_ADD_ONS) {
      value?.map((item) => {
        item?.plan_details?.map(() => {
          sum = sum + 1;
        });
      });
    } else {
      sum = value?.filter(({ subscription_id }) => !subscription_id)?.length || 0;
    }
    return sum;
  };

  if (!hide) return null;

  return (
    <Wrapper className="mb-4">
      {loader && <Loader position="absolute" loader={true} backdrop />}
      <TitleAndLinkWrapper
        title={<>Additional Add-Ons</>}
        description={<>Your purchased add-ons details.</>}
        style={{
          borderLeftStyle: 'none',
          borderRightStyle: 'none',
          borderTopStyle: 'none',
          borderRadius: 0,
        }}
      />
      <div className={`${styles.purchasedInfo} w-100 bg-white`}>
        <Tabs defaultActiveKey={+tab} activeKey={+tab} className="px-4" onSelect={handleTabChange}>
          <Tab
            eventKey={AddOnsTab?.RECURRING_ADD_ONS}
            title={`Recurring add-ons (${handlePurchasedAddonsLengthCount(
              data,
              AddOnsTab?.RECURRING_ADD_ONS
            )})`}></Tab>
          <Tab
            eventKey={AddOnsTab?.ONE_TIME_ADD_ONS}
            title={`One time add-ons (${handlePurchasedAddonsLengthCount(
              oneTimeAddOns,
              AddOnsTab?.ONE_TIME_ADD_ONS
            )})`}></Tab>
        </Tabs>
        <Table className={styles.purchasedTable}>
          <thead>
            <tr>
              <th>Item</th>
              <th>Quantity</th>
              <th>Available/Total</th>
            </tr>
          </thead>
          <tbody>
            {+tab === AddOnsTab?.ONE_TIME_ADD_ONS ? (
              <>
                {oneTimeAddOns && oneTimeAddOns?.length ? (
                  oneTimeAddOns?.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr key={index}>
                          <td>
                            <h6>{item?.name}</h6>
                          </td>
                          <td>
                            <p className="me-2 ">{item?.total_count}</p>
                          </td>
                          <td>
                            <p className="me-2">{`${item?.available_count || 0} / ${
                              item?.total_count || 0
                            }`}</p>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <p className="p-4">{`You don't have any one-time add-ons.`}</p>
                )}
              </>
            ) : (
              <>
                {data && data?.length > 0 ? (
                  data?.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        {item?.plan_details &&
                          item?.plan_details?.length > 0 &&
                          item?.plan_details?.map((child, idx) => {
                            return (
                              <React.Fragment key={idx}>
                                <tr key={idx}>
                                  <td>
                                    <h6>
                                      {child?.plan_name} ({getPlanRecurringPeriod(item)}
                                    </h6>
                                    <p>
                                      Purchased on{' '}
                                      {format(new Date(item?.created_at), 'MMM dd, yyyy - hh:mm a')}
                                    </p>
                                  </td>
                                  <td>
                                    <>
                                      <p className="me-2 ">
                                        {child?.item_counts?.total_count || child?.product_quantity}
                                      </p>
                                      {+child?.to_remove_product_quantity > 0 && (
                                        <p>
                                          {`${child?.to_remove_product_quantity} Add-ons scheduled will be removed at expired`}
                                        </p>
                                      )}
                                    </>
                                  </td>
                                  <td>
                                    <p className="me-2">{`${
                                      child?.item_counts?.available_count || 0
                                    } / ${child?.item_counts?.total_count || 0}`}</p>
                                  </td>
                                </tr>
                              </React.Fragment>
                            );
                          })}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <p className="p-4">{`You don't have any add-ons currently.`}</p>
                )}
              </>
            )}
          </tbody>
        </Table>
      </div>
    </Wrapper>
  );
};

export const ExpiredPlanList = ({ expiredPlanList }) => {
  const [open, toggle] = useState(false);

  if (expiredPlanList?.length === 0) return null;
  return (
    <Wrapper className="mb-4">
      <TitleAndLinkWrapper
        title={'Expired Plans'}
        style={{
          borderLeftStyle: 'none',
          borderRightStyle: 'none',
          borderTopStyle: 'none',
          borderRadius: 0,
        }}
        isOpen={open}
        onToggle={() => toggle(!open)}
        makeItExpandable={true}
      />
      <div
        className={`${styles.purchasedInfo} w-100 bg-white`}
        style={!open ? { display: 'none' } : {}}>
        <Table className={styles.purchasedTable}>
          <thead>
            <tr>
              <th>
                <strong>
                  <small>Plan Name</small>
                </strong>
              </th>
              <th>
                <strong>
                  <small>Expired Date</small>
                </strong>
              </th>
            </tr>
          </thead>
          <tbody>
            {expiredPlanList?.map((item, index) => (
              <tr key={item.id}>
                <td>
                  {item?.plan_details[0]?.plan_name} {getPlanRecurringPeriod(item)}
                </td>
                <td>
                  {item?.current_period_end_timestamp
                    ? getDateFromTimestamp(item?.current_period_end_timestamp)
                    : 'N/A'}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Wrapper>
  );
};

export const CurrentPlanListContainerV2 = ({
  expiresOnTimestamp = null,
  isActivePlan = false,
  isCancelAtPeriodEnd = false,
  loading = false,
  onClick = () => {},
  upgradeButtonText = 'Upgrade plan',
  showUpgradeButton = false,
  allPlanList: purchasedPlansList = [],
  isPlanDowngraded = null,
  downgradedPlanDetail,
  showTab = {},
  dataForSegment = {},
  setModifySubscription = () => {},
}) => {
  const { currentPlanIsCancelled } = useSubscriptionPurchase();
  const { isFreemiumUser, isOldSubscriptionUser, currentUser, isGuestUser, freeTrialInfo } =
    useUserContext();
  const { isFreemiumOrSelfServeUser, hideNewPlans } = useCurrentOrganizationInfo();
  const [tab, setTab] = useState(PLAN_TYPE_TAB.CURRENT);
  const [cancelLoader, setCancelLoader] = useState(false);
  const dispatch = useDispatch();

  const isActivePlanNotARequest = isActivePlan && purchasedPlansList?.find(a => !a.is_request && (a.is_active_main_subscription_plan || a.is_upload_limit_plan)); // here, checking if the current plan is active and it is purchased from the material request
  const isPlanActiveAndNotCancel = isActivePlan && !isCancelAtPeriodEnd;
  const isPlanActiveAndCancel = isFreemiumOrSelfServeUser
    ? currentPlanIsCancelled?.()
    : isActivePlan && isCancelAtPeriodEnd;
  const oldSubscriptionPlanName =
    currentUser?.organization_detail?.subscription_name || 'imagine.io';
  const { trackClickEvent } = userPilotEvents();

  // Sort the purchased plans list by their recurring interval
  let _purchasedPlansList = purchasedPlansList?.sort(
    (a, b) => a?.recurring_interval - b?.recurring_interval
  );

  // Check if there is any plan with the Editor add-on and a yearly recurring interval
  const haveYearlyEditor = _purchasedPlansList?.some((plan) =>
    plan?.plan_details?.find(
      (plan) =>
        plan?.basemodeltype === ADD_ONS_PRODUCT_BASE_NAME.Editor &&
        +plan?.recurring_interval_id === RECURRING_INTERVAL.YEAR
    )
  );

  // Check if there is any plan with the Editor add-on and a monthly recurring interval
  const haveMonthlyEditor = _purchasedPlansList?.some((plan) =>
    plan?.plan_details?.find(
      (plan) =>
        plan?.basemodeltype === ADD_ONS_PRODUCT_BASE_NAME.Editor &&
        +plan?.recurring_interval_id === RECURRING_INTERVAL.MONTH
    )
  );

  /**
   * If the user is a Freemium or self-serve user, and is not a Freemium user, and the current tab is the "Current" tab,
   * the function filters the purchased plans list to include only the plans with a monthly or yearly recurring interval
   * that have the Editor add-on.
   *
   * And, the priority is given to the Editor add-on with a yearly recurring interval.
   */
  const allPlanList = useMemo(() => {
    let list = _purchasedPlansList,
      result = [];
    if (isFreemiumOrSelfServeUser && !isFreemiumUser() && tab === PLAN_TYPE_TAB.CURRENT) {
      if (haveMonthlyEditor) {
        result = _purchasedPlansList.filter(
          (a) => a?.recurring_interval === RECURRING_INTERVAL.MONTH && !a?.is_cancelled
        );
        if (result?.length) {
          list = result;
        }
      }
      if (haveYearlyEditor) {
        result = _purchasedPlansList.filter(
          (a) => a?.recurring_interval === RECURRING_INTERVAL.YEAR && !a?.is_cancelled
        );
        if (result?.length) {
          list = result;
        }
      }
    }
    // for quick fix I added this code...
    // we need to refactor this entire functions
    if (isFreemiumOrSelfServeUser && isFreemiumUser() && tab === PLAN_TYPE_TAB.CURRENT) {
      list = [
        {
          plan_name: 'Free',
          isCurrentPlan: true,
          description: 'You are currently on the Free plan',
          showBilling: false,
          isFreemium: true,
        },
      ];
    }
    if (tab === PLAN_TYPE_TAB.EXPIRED) {
      list = _purchasedPlansList.filter((a) => a?.is_cancelled && a?.status === 'deleted');
    }
    return list;
  }, [isFreemiumOrSelfServeUser, _purchasedPlansList, tab, haveMonthlyEditor, haveYearlyEditor]);

  const handleCancelDowngradePlanRequest = async (plan) => {
    const activePlan = allPlanList?.find(
      ({ is_active_main_subscription_plan, is_cancelled, is_downgrade_scheduled, status , is_ai_imagine_subscription, is_ai_imagine, is_ai_imagine_one_time }) =>
        is_active_main_subscription_plan &&
        !is_cancelled &&
        !is_ai_imagine_subscription &&
        !is_ai_imagine &&
        !is_ai_imagine_one_time &&
        is_downgrade_scheduled &&
        status === 'active'
    );
    if (!activePlan?.id) return null;
    const payload = {
      is_cancel_pending_downgrade: true,
    };
    setCancelLoader(true);
    const res = await updateUploadLimitSubscription(activePlan?.id, payload);
    setCancelLoader(false);
    if (res?.status) {
      dispatch(setClientSubscriptionPlans());
      successToast('Plan downgrade schedule has been cancelled successfully.');
      setTab(PLAN_TYPE_TAB.CURRENT);
    }
  };

  const handleShowPlanDescription = ({
    value,
    activePlan,
    downgradedPlan,
    downgradedPlanDetail,
    expiredPlan,
    canceledPlan,
    isFreemiumPlan,
    isPlanActiveAndCancel,
  }) => {
    if (isPlanActiveAndCancel && tab === PLAN_TYPE_TAB.CURRENT) {
      return `This plan is set to cancel on ${getDateFromTimestamp(
        value?.current_period_end_timestamp,
        false
      )}.`;
    }
    if (isFreemiumPlan) {
      return 'You are currently on the Free plan.';
    }
    if (expiredPlan) {
      return `This plan is expired at ${getDateFromTimestamp(
        value?.current_period_end_timestamp,
        false
      )}.`;
    }
    if (canceledPlan) {
      return `This plan is set to cancel on ${getDateFromTimestamp(
        value?.current_period_end_timestamp,
        false
      )}.`;
    }
    if (activePlan) {
      if (value?.downgraded_plan_id && downgradedPlanDetail?.plan_name) {
        return `You will be downgraded to ${
          downgradedPlanDetail?.plan_name
        } on ${getDateFromTimestamp(expiresOnTimestamp, false)}.`;
      }
      return `This plan will ${downgradedPlan ? 'expire' : 'be renewed'}  on ${getDateFromTimestamp(
        value?.current_period_end_timestamp,
        false
      )}.`;
    }
    return getCurrentSubscriptionPlanMessage(currentUser);
  };

  const handleTabChange = (key) => {
    setTab(+key);
  };
  const _showTab = showTab;

  const addDataToSegment = () => {
    if (dataForSegment?.Current_Plan_Name) {
      callTrackEvent('Modify Plan', dataForSegment, true);
    }
  };

  const modifyPlan = () => {
    setModifySubscription?.(true);
    addDataToSegment();
  };

  return (
    <Wrapper className={cx('mb-4', isFreemiumOrSelfServeUser ? styles.designV2 : '')}>
      {loading && <Loader position="absolute" loading backdrop />}
      {!isFreemiumOrSelfServeUser ? (
        <TitleAndLinkWrapper
          title="My Plans"
          style={{
            background: '#fff',
            border: 'none',
            borderRadius: 0,
            paddingBottom: 0,
          }}
          btnClassName="black-btn"
          {...(isPlanActiveAndNotCancel || isOldSubscriptionUser()  &&
            !isGuestUser() && {
              buttonText: 'Review plan',
              onClick: () => dispatch(subscriptionActions.setBrowsePlans(true)),
            })}
          {...(isPlanActiveAndCancel &&
            !isGuestUser() && {
              buttonText: 'Restore plan',
              onClick: onClick,
            })}
          {...(showUpgradeButton &&
            !isGuestUser() &&
            !hideNewPlans && {
              buttonText: upgradeButtonText,
              onClick: onClick,
            })}
        />
      ) : null}
      <div className={styles.planTypeTab}>
        <Tabs defaultActiveKey={+tab} activeKey={+tab} onSelect={handleTabChange}>
          {_showTab?.current && <Tab eventKey={PLAN_TYPE_TAB.CURRENT} title="Current"></Tab>}
          {_showTab?.downgradedPlan && (
            <Tab eventKey={PLAN_TYPE_TAB.DOWNGRADED} title="Downgraded"></Tab>
          )}
          {_showTab?.expired && <Tab eventKey={PLAN_TYPE_TAB.EXPIRED} title="Expired"></Tab>}
        </Tabs>
        {!isGuestUser() && !isFreemiumOrSelfServeUser ? (
          <div className="float-end d-flex gap-3">
            <ActionLink
              title={'Go to billing'}
              onClick={() => navigateToBilling({ newTab: false })}
            />
          </div>
        ) : null}
      </div>
      <div className={styles.allPlanCard}>
        {allPlanList?.filter(Boolean)?.map((list) => {
          const isCreatorPlan = list?.plan_details?.some(({ is_custom_plan }) => (is_custom_plan && !list.is_request));  // filtering the plan that are purchased in material request with key 'is_request'
          const isFreemiumPlan =
            tab === PLAN_TYPE_TAB.CURRENT ? list?.isFreemium || isFreemiumUser() || false : false;
          const activePlan = list?.isFreemium
            ? true
            : !list?.is_cancelled && list?.status === 'active';
          const downgradedPlan =
            isPlanDowngraded === list?.stripe_price_id || list?.downgraded_plan_id ? true : false;
          const { is_cancelled, status, is_add_on_subscription } = list || {};
          const expiredPlan =
            is_cancelled === true && status === 'deleted' && !is_add_on_subscription;
          const canceledPlan = isFreemiumPlan
            ? false
            : list?.is_cancelled || list?.cancel_at_period_end;

          const isActiveFreeTrial =
            isFreemiumPlan && freeTrialInfo?.isFreeTrialStarted && !freeTrialInfo?.isFreeTrialExpired;

          let planName = isFreemiumPlan
            ? isActiveFreeTrial
              ? 'Free Trial'
              : 'Free'
            : isCreatorPlan
            ? 'Creator plan'
            : list?.plan_details?.[0]?.price_nickname || list?.plan_details?.[0]?.plan_name || list?.plan_name;
          if (!planName) {
            planName = isFreemiumUser()
              ? 'Free'
              : isOldSubscriptionUser()
              ? oldSubscriptionPlanName
              : '';
          }
          // for quick fix I added this code...
          // we need to refactor this entire functions
          if (planName === 'Free' && tab === PLAN_TYPE_TAB.EXPIRED && list?.is_upload_limit_plan) {
            planName = 'Creator plan';
          }
          if (!planName && tab === PLAN_TYPE_TAB.EXPIRED && list?.is_upload_limit_plan) {
            planName = 'Creator plan';
          }
          if (
            planName !== 'Creator plan' &&
            tab === PLAN_TYPE_TAB.EXPIRED &&
            isFreemiumOrSelfServeUser
          ) {
            planName = 'Creator plan';
          }
          const planInterval = isFreemiumPlan
            ? false
            : +list?.recurring_interval || +list?.plan_details?.[0]?.recurring_interval_id || false;
          const planPrice = isCreatorPlan
            ? calculatePlanPrice({ plan: list, checkForCancelledPlan: true })
            : convertStripeCentsToAmount(
                +list?.plan_details?.[0]?.price_amount || +list?.unit_amount || 0
              );
          const priceLabel =
            planPrice && planInterval && !isFreemiumPlan
              ? `$${planPrice} / ${getPlanRecurringPeriod(list)
                  ?.replace('Per ', '')
                  ?.replace('ly', '')
                  ?.toLowerCase()}`
              : null;

          const description = isActiveFreeTrial
            ? `Your free trial ends on ${freeTrialInfo?.freeTrialEndDateFormatted}`
            : list?.description ||
              handleShowPlanDescription({
                value: list,
                activePlan,
                downgradedPlan,
                downgradedPlanDetail,
                expiredPlan,
                canceledPlan,
                isFreemiumPlan,
                isPlanActiveAndCancel,
              });
          if (tab === PLAN_TYPE_TAB.CURRENT && expiredPlan && !isFreemiumPlan) {
            return null;
          }
          if (tab !== PLAN_TYPE_TAB.CURRENT && !list) {
            return null;
          }
          if (tab === PLAN_TYPE_TAB.DOWNGRADED && downgradedPlan && downgradedPlanDetail) {
            const price = convertStripeCentsToAmount(+downgradedPlanDetail?.unit_amount || 0);
            const priceValue =
              price && downgradedPlanDetail?.recurring_interval && !isFreemiumPlan
                ? `$${price} / ${getPlanRecurringPeriod(downgradedPlanDetail)
                    ?.replace('Per ', '')
                    ?.replace('ly', '')
                    ?.toLowerCase()}`
                : null;
            return (
              <div className={styles.planCardBox} key={list?.id}>
                <h4>
                  {downgradedPlanDetail?.plan_name || downgradedPlanDetail?.nickname || planName}
                </h4>
                {priceValue ? <h6>{priceValue}</h6> : null}
                <p>{description} </p>
              </div>
            );
          }
          if (
            (expiredPlan && tab === PLAN_TYPE_TAB.DOWNGRADED) ||
            (tab === PLAN_TYPE_TAB.DOWNGRADED && !downgradedPlan && !downgradedPlanDetail)
          ) {
            return null;
          }
          if (tab === PLAN_TYPE_TAB.EXPIRED && !expiredPlan) {
            return null;
          }
          // tab is downgraded and plan don't have the downgraded_plan_id then we don't show that plan in downgrade section
          if (tab === PLAN_TYPE_TAB.DOWNGRADED && !list?.downgraded_plan_id) {
            return null;
          }

          return (
            <div className={styles.planCardBox} key={list?.id}>
              {/* <span>
                {handleShowPlanStatus(list, activePlan, downgradedPlan, expiredPlan, canceledPlan)}
              </span> */}
              {/* <h4>{`Imagine ${planName}`}</h4> */}
              <h4>{planName}</h4>
              {priceLabel ? <h6>{priceLabel}</h6> : null}
              <p>{description} </p>
            </div>
          );
        })}
      </div>
      {!isGuestUser() &&
      isFreemiumOrSelfServeUser &&
      tab === PLAN_TYPE_TAB.DOWNGRADED &&
      downgradedPlanDetail ? (
        <Button
          size="lg"
          className={styles.cancelDowngrade}
          loading={cancelLoader}
          onClick={() => handleCancelDowngradePlanRequest()}>
          Cancel Downgrade Request
        </Button>
      ) : null}
      {!isGuestUser() && !isFreemiumUser() && isFreemiumOrSelfServeUser && !hideNewPlans && isActivePlanNotARequest ? (
        <Button
          size="lg"
          className={styles.actionBtn}
          loading={loading}
          onClick={() => {
            trackClickEvent('Creator plan', {
              plan: 'Creator',
              is_manage_subscription: true,
              is_yearly: allPlanList?.[0]?.recurring_interval === 2,
            });
            isPlanActiveAndCancel ? onClick?.() : modifyPlan();
          }}>
          {isPlanActiveAndCancel ? 'Restore plan' : 'Manage Subscription'}
        </Button>
      ) : null}
    </Wrapper>
  );
};

export const AvailableItemsContainerV2 = ({
  isActivePlan = false,
  isCancelAtPeriodEnd = false,
  showTooltip = true,
  loading = false,
  showProductUsageHistoryButton = false,
  planName = '',
  updateSegmentData,
  setModifySubscription = () => {},
}) => {
  const { currentUser, isGuestUser, isPremiumUser } = useUserContext();
  const { isFreemiumOrSelfServeUser, isPremiumAndSelfServePlan, isFreemiumUser } = useUserContext();
  const { imagineCreditLimit } = useSubscriptionPurchase(); 
  const { hideNewPlans } = useCurrentOrganizationInfo();
  const allPurchasePlan = useSelector(selectAllPurchasedPlanListSelector);
  const userPlans = useSelector(selectUserPlanList);
  const [selectedCardProductId, setSelectedCardProductId] = useState(null);
  const [userStats, setUserStats] = useState([]);
  const [loader, setLoader] = useState(false);
  const [filterCounts, setFilterCounts] = useState([]);
  const purchaseAddOnsList = useSelector(selectPurchaseAddOns);
  const { results } = purchaseAddOnsList || {};
  const unlimitedRenderingPackRef = useRef();
  const [dataForSegment, setDataForSegment] = useState(null);
  const { flag: addOnSuccessFlag } = useSelector(selectAddOnSuccessFlag);

  useEffect(() => {
    if (filterCounts?.length) {
      const modelVariation = filterCounts?.find(
        (val) => val.basemodeltype === '3D Model variation'
      );
      const configurator = filterCounts?.find((val) => val.basemodeltype === 'Configurator');
      const video = filterCounts?.find((val) => val.basemodeltype === 'Video');
      const texture = filterCounts?.find((val) => val.basemodeltype === 'Texture');
      const editor = filterCounts?.find((val) => val.basemodeltype === 'Editor');
      const model = filterCounts?.find((val) => val.basemodeltype === '3D Models Upload Limit');
      const arView = filterCounts?.find((val) => val.basemodeltype === '360 Viewer + AR');

      const dataForSegment = {
        Current_Plan_Name: planName || '',
        Model_Used: model?.used_count || 0,
        Model_Limit: model?.total_count || 0,
        Textures_Used: texture?.used_count || 0,
        Textures_Limit: texture?.total_count || 0,
        Editor_Seat: editor?.available_count || 0,
        Videos_Used: video?.used_count || 0,
        Videos_Limit: video?.total_count || 0,
        Configurator_Used: configurator?.used_count || 0,
        Configurator_Limit: configurator?.total_count || 0,
      };
      dataForSegment['3d_Model_Variations_Used'] = modelVariation?.used_count || 0;
      dataForSegment['3d_Model_Variations_Limit'] = modelVariation?.total_count || 0;
      dataForSegment['3DViewer_AR_Used'] = arView?.used_count || 0;
      dataForSegment['3DViewer_AR_Limit'] = arView?.total_count || 0;
      setDataForSegment(dataForSegment);
      updateSegmentData?.(dataForSegment);
    }
  }, [filterCounts]);

  const initialGetCountAPI = async () => {
    setLoader(true);
    const count = await apiGetAllProductUsedCount();
    setTimeout(() => {
      setLoader(false);
    }, 0);
    setUserStats(count?.results || []);
  };

  useEffect(() => {
    initialGetCountAPI();
  }, [currentUser?.organization]);

  useEffect(() => {
    if (addOnSuccessFlag) {
      initialGetCountAPI();
    }
  }, [addOnSuccessFlag]);

  useEffect(() => {
    if (userStats?.length) {
      handleFilterItems(userStats);
    } else {
      userStats?.length && setUserStats([]);
    }
  }, [userStats]);

  const handleFilterItems = (value = userStats.slice()) => {
    setFilterCounts(mergeDuplicates(value)?.sort((a, b) => a.product_id - b.product_id));
  };

  const mergeDuplicates = (data) => {
    let mergedData = {};
    data.forEach((item) => {
      const name =
        item.basemodeltype?.toLowerCase() === 'images'
          ? Object.keys(mergedData)?.find((_item) =>
              _item?.toLowerCase()?.includes(item?.name?.toLowerCase())
            ) || item?.name
          : item.basemodeltype;
      if (name) {
        if (mergedData[name]) {
          mergedData[name].name = name;
          mergedData[name].total_count += item.total_count;
          mergedData[name].used_count += item.used_count;
          mergedData[name].available_count += item.available_count;
        } else {
          mergedData[name] = { ...item, name };
        }
      }
    });
    unlimitedRenderingPackRef.current = mergedData?.[UNLIMITED_RENDERING];
    if (unlimitedRenderingPackRef.current) {
      mergedData = { ...mergedData, [UNLIMITED_RENDERING]: unlimitedRenderingPackRef.current };
    }
    return Object.values(mergedData);
  };

  const addDataToSegment = () => {
    if (dataForSegment) {
      callTrackEvent('My Plan Homepage LP', dataForSegment, true);
    }
  };

  const getRecurringInterval = (sid = null) => {
    if (!sid) return null;
    let plan = userPlans?.find((plan) => plan?.id === sid);
    if (!plan && allPurchasePlan) {
      plan = allPurchasePlan?.find((plan) => plan?.id === sid);
    }
    return plan?.recurring_interval;
  };

  const enableEditForList = (basemodeltype) =>
    [ADD_ONS_PRODUCT_BASE_NAME.Configurator, ADD_ONS_PRODUCT_BASE_NAME['3D_Viewer']].includes(
      basemodeltype
    );

  const filterModalDetails = () => {
    let modalValueValue = filterCounts?.find((a) => a.product_id === selectedCardProductId);
    if (modalValueValue) {
      let list = userStats.filter(({ basemodeltype, name }) =>
        basemodeltype?.toLowerCase() === 'images'
          ? modalValueValue?.name?.includes(name)
          : basemodeltype === modalValueValue?.name
      );
      // Add available count and total count of addons if subscription id , is one time and is addon values are same
      list = list.reduce((a, c) => {
        let flag = false;
        const calcualateAddonAddons = a.map((_item) => {
          if (
            (_item?.is_manually && c?.is_manually && _item?.basemodeltype === c?.basemodeltype) ||
            (_item?.basemodeltype === c?.basemodeltype &&
              _item?.pack_productid === c?.pack_productid &&
              _item?.subscription_id === c?.subscription_id &&
              _item?.is_manually === c?.is_manually &&
              _item?.is_one_time === c?.is_one_time &&
              _item?.is_add_on === c?.is_add_on)
          ) {
            flag = true;
            return {
              ..._item,
              total_count: _item.total_count + c.total_count,
              used_count: _item.used_count + c.used_count,
              available_count: _item.available_count + c.available_count,
            };
          }
          return _item;
        });

        if (flag) return calcualateAddonAddons;
        else return [...a, c];
      }, []);

      let itemsFrom = [];
      if (list?.length) {
        list.map((info) => {
          let cloneInfo = { ...info },
            showToolTip = null;
          // if (modalValueValue?.name === SUBSCRIPTION_MODEL_TYPE.THREE_D_MODEL) {
          //   cloneInfo.total_count = Math.floor(info?.total_count / 2);
          // }
          // if (info?.is_upload_limit_plan) {
          //   const indVal = itemsFrom?.findIndex(({ name }) => name === `Upload limit upgrade`);
          //   if (~indVal) {
          //     itemsFrom[indVal].qty = +itemsFrom[indVal]?.qty + +cloneInfo?.total_count;
          //     return;
          //   } else {
          //     itemsFrom.push({
          //       id: itemsFrom?.length + 1,
          //       qty: cloneInfo?.total_count,
          //       name: `Upload limit upgrade`,
          //       tooltip: showToolTip,
          //       seq: 1,
          //       subscription_id: info?.subscription_id,
          //       product_id: info?.product_id,
          //       basemodeltype: cloneInfo?.basemodeltype,
          //     });
          //   }
          //   return;
          // }

          if (
            info?.basemodeltype === MATTRESS_BUILDER_BASE_TYPE &&
            info?.is_add_on &&
            !info?.is_manually
          ) {
            const recurringInterval = getRecurringInterval(info?.subscription_id);
            const isMonthly = recurringInterval === RECURRING_INTERVAL.MONTH;
            const indVal = itemsFrom?.findIndex(({ basemodeltype, name }) =>
              isMonthly ? name === 'Monthly' : name === 'Yearly'
            );
            if (~indVal) {
              itemsFrom[indVal].qty = +itemsFrom[indVal]?.qty + +cloneInfo?.total_count;
            } else {
              itemsFrom.push({
                id: itemsFrom?.length + 1,
                qty: cloneInfo?.total_count,
                name: isMonthly ? 'Monthly' : 'Yearly',
                tooltip: '',
                seq: 3,
                subscription_id: info?.subscription_id,
                product_id: info?.product_id,
                basemodeltype: cloneInfo?.basemodeltype,
                interval: getRecurringInterval(info?.subscription_id),
                isEdit: true,
                isMattressBuilder: true,
              });
            }
            return;
          }

          if (isFreemiumOrSelfServeUser && info?.is_upload_limit_plan && info?.subscription_id) {
            const recurringInterval = getRecurringInterval(info?.subscription_id);
            const isMonthly = recurringInterval === RECURRING_INTERVAL.MONTH;

            const indVal = itemsFrom?.findIndex(({ basemodeltype, name }) =>
              name === 'One time add-ons' || isMonthly ? name === 'Monthly' : name === 'Yearly'
            );
            if (~indVal) {
              itemsFrom[indVal].qty = +itemsFrom[indVal]?.qty + +cloneInfo?.total_count;
            } else {
              itemsFrom.push({
                id: itemsFrom?.length + 1,
                qty: cloneInfo?.total_count,
                name: info?.is_one_time ? 'One time add-ons' : isMonthly ? 'Monthly' : 'Yearly',
                tooltip: showToolTip,
                seq: 1,
                subscription_id: info?.subscription_id,
                product_id: info?.product_id,
                basemodeltype: cloneInfo?.basemodeltype,
                interval: getRecurringInterval(info?.subscription_id),
                isEdit: enableEditForList(cloneInfo?.basemodeltype),
              });
            }
            return;
          }

          if (info?.is_manually) {
            itemsFrom.push({
              id: itemsFrom?.length + 1,
              qty: cloneInfo?.total_count,
              name: 'Other items',
              tooltip: showToolTip,
              seq: 4,
              subscription_id: info?.subscription_id,
              product_id: info?.product_id,
              basemodeltype: cloneInfo?.basemodeltype,
            });
            return;
          }

          if (info?.is_freemium) {
            itemsFrom.push({
              id: itemsFrom?.length + 1,
              qty: cloneInfo?.total_count,
              name: 'Freemium',
              tooltip: showToolTip,
              seq: 5,
              subscription_id: info?.subscription_id,
              product_id: info?.product_id,
              basemodeltype: cloneInfo?.basemodeltype,
            });
            return;
          }

          if (info?.pack_productid) {
            itemsFrom.push({
              id: itemsFrom?.length + 1,
              qty: cloneInfo?.total_count,
              name: `${info?.pack_product_name}`,
              tooltip: showToolTip,
              seq: 4,
              subscription_id: info?.subscription_id,
              product_id: info?.product_id,
              basemodeltype: cloneInfo?.basemodeltype,
            });
            return;
          }
          if (info?.subscription_id) {
            const planDetails = userPlans.find((plan) => +plan?.id === +info?.subscription_id);
            const planName = planDetails?.plan_details?.[0]?.plan_name || null;
            const planRecurringInterval =
              planDetails?.recurring_interval ||
              planDetails?.plan_details?.[0]?.recurring_interval_id;
            const record = results?.find(({ id }) => +info?.subscription_id === +id);
            const intervalVal = record?.recurring_interval || planRecurringInterval;
            const recurringAddons = info?.is_add_on && !info?.is_one_time;            
            const addonsDetails =
              record?.plan_details
                ?.filter(
                  ({ basemodeltype }) =>
                    basemodeltype?.toLowerCase() === TEXTURE_PRODUCT_NAME?.toLowerCase()
                )
                ?.reduce((a, c) => {
                  if (a?.basemodeltype === c?.basemodeltype) {
                    // const itemsCount = a?.plan_id !== c?.plan_id ?
                    //   {
                    //     item_counts:
                    //     {
                    //       total_count: a.item_counts.total_count + c.item_counts.total_count,
                    //       used_count: a.item_counts.used_count + c.item_counts.used_count,
                    //       available_count: a.item_counts.available_count + c.item_counts.available_count
                    //     }
                    //   } : {}
                    return {
                      ...a,
                      // ...itemsCount,
                      product_quantity: a.product_quantity + c.product_quantity,
                      to_remove_product_quantity:
                        a.to_remove_product_quantity + c.to_remove_product_quantity,
                    };
                  }
                  return c;
                }, {}) || [];
            const removeItemQTY = addonsDetails?.to_remove_product_quantity;
            const productItemQTY = addonsDetails?.product_quantity;
            const itemCount = addonsDetails?.item_counts?.total_count;
            const bundleSize = parseInt(itemCount / (+productItemQTY + (+removeItemQTY || 0)));
            if (
              (TEXTURE_PRODUCT_ID === +cloneInfo?.product_id ||
                cloneInfo?.basemodeltype === TEXTURE_PRODUCT_NAME) &&
              recurringAddons
            ) {
              showToolTip = `When you purchase one unit, you'll receive a bundle of ${
                bundleSize || 100
              } textures`;
            }
            const alreadyData = itemsFrom?.findIndex(({subscription_id, basemodeltype}) =>  basemodeltype === cloneInfo?.basemodeltype && subscription_id === info?.subscription_id)
            if(~alreadyData){
              itemsFrom[alreadyData].qty = +itemsFrom[alreadyData].qty + +cloneInfo?.total_count
              return
            }
            itemsFrom.push({
              id: itemsFrom?.length + 1,
              qty: cloneInfo?.total_count,
              name: planName
                ? `${planName} subscription plan ${
                    planRecurringInterval
                      ? `(${getPlanRecurringPeriod(planDetails || record)})`
                      : ''
                  }`
                : recurringAddons
                ? `Recurring add-ons ${
                    intervalVal ? `(${getPlanRecurringPeriod(planDetails || record)})` : ''
                  }`
                : 'One time add-ons',
              interval: intervalVal,
              isEdit: recurringAddons,
              tooltip: showToolTip,
              seq: recurringAddons ? 2 : 1,
              subscription_id: info?.subscription_id,
              product_id: info?.product_id,
              basemodeltype: cloneInfo?.basemodeltype,
            });
            return;
          }
          if (
            TEXTURE_PRODUCT_ID === +cloneInfo?.product_id ||
            cloneInfo?.basemodeltype === TEXTURE_PRODUCT_NAME
          ) {
            showToolTip = `When you purchase one unit, you'll receive a bundle of 100 textures`;
          }
          if (info?.is_add_on && !info?.is_one_time) {
            const record = results?.find(({ id }) => +info?.subscription_id === +id);
            const intervalVal = record?.recurring_interval;
            itemsFrom.push({
              id: itemsFrom?.length + 1,
              qty: cloneInfo?.total_count,
              name: `Recurring add-ons ${intervalVal ? `(${getPlanRecurringPeriod(record)})` : ''}`,
              interval: intervalVal,
              isEdit: !!record,
              tooltip: showToolTip,
              seq: 2,
              subscription_id: info?.subscription_id,
              product_id: info?.product_id,
              basemodeltype: cloneInfo?.basemodeltype,
            });
            return;
          }

          if (info?.is_add_on && !info?.is_one_time) {
            const record = results?.find(({ id }) => +info?.subscription_id === +id);
            const intervalVal = record?.recurring_interval;
            itemsFrom.push({
              id: itemsFrom?.length + 1,
              qty: cloneInfo?.total_count,
              name: `Recurring add-ons ${intervalVal ? `(${getPlanRecurringPeriod(record)})` : ''}`,
              interval: intervalVal,
              isEdit: !!record,
              tooltip: showToolTip,
              seq: 2,
              subscription_id: info?.subscription_id,
              product_id: info?.product_id,
              basemodeltype: cloneInfo?.basemodeltype,
            });
            return;
          }
          if (info?.is_add_on && !info?.subscription_id && !info?.is_manually) {
            const indVal = itemsFrom?.findIndex(({ name }) => name === 'One time add-ons');
            if (~indVal) {
              itemsFrom[indVal].qty = +itemsFrom[indVal]?.qty + +cloneInfo?.total_count;
            } else {
              itemsFrom.push({
                id: itemsFrom?.length + 1,
                qty: cloneInfo?.total_count,
                name: 'One time add-ons',
                tooltip: showToolTip,
                seq: 3,
                subscription_id: info?.subscription_id,
                product_id: info?.product_id,
                basemodeltype: cloneInfo?.basemodeltype,
              });
            }
            return;
          }
        });
      }
      modalValueValue.itemsFrom = itemsFrom;
    }
    return modalValueValue;
  };

  // useEffect(() => {
  //   console.log('DEBUG__modalValue', {
  //     userStats,
  //     modalValue: filterModalDetails(),
  //     filterCounts,
  //     userPlans,
  //   });
  // }, [filterModalDetails, filterCounts, userStats, userPlans]);

  const isPlanActiveAndNotCancel = isActivePlan && !isCancelAtPeriodEnd;
  if (!filterCounts?.length && !imagineCreditLimit?.id) {
    return null;
  }
  addDataToSegment(filterCounts);
  if (isFreemiumOrSelfServeUser) {
    const ALLOWED = [
      ADD_ONS_PRODUCT_BASE_NAME.Model3DUploadLimit,
      ADD_ONS_PRODUCT_BASE_NAME.Texture,
      ADD_ONS_PRODUCT_BASE_NAME.Editor,
    ].map((a) => a.toLowerCase());

    let _includedInPlans = filterCounts?.filter((a) =>
      ALLOWED.includes(a.basemodeltype?.toLowerCase())
    );
    const _addonsLimit = filterCounts?.filter(
      (a) => !ALLOWED.includes(a.basemodeltype?.toLowerCase())
    );

if (imagineCreditLimit?.length > 0) {
  imagineCreditLimit.forEach((creditLimit) => {
    _includedInPlans.push({
      name: creditLimit?.basemodeltype || 'Imagine Credits',
      pack_productid: null,
      pack_product_name: null,
      is_add_on: true,
      is_one_time: true,
      is_pack_product: false,
      is_manually: true,
      is_freemium: true,
      total_count: +creditLimit?.total_limit,
      used_count: formatNumber(+creditLimit?.total_limit - +creditLimit?.available_limit),
      available_count: +creditLimit?.available_limit,
      subscription_id: null,
      product_id: null,
      basemodeltype: creditLimit?.basemodeltype,
      is_upload_limit_plan: null,
    });
  });
}
    return (
      <>
        {_includedInPlans?.length > 0 && (
          <Wrapper
            className={`mb-4 ${isFreemiumOrSelfServeUser ? styles.availableAddonsDesignV2 : ''}`}>
            {loading ||
              (loader && (
                <Loader position="absolute" style={{ backgroundColor: '#fff' }} loading backdrop />
              ))}
            <Wrapper
              title="Included in plan"
              className={styles.addonsContainer}
              childrenClassName={'gap-3'}
              {...((showProductUsageHistoryButton ||
                isPlanActiveAndNotCancel ||
                isFreemiumOrSelfServeUser) &&
                !isGuestUser() && {
                  productUsageViewTitle: 'View usage history',
                  productUsageViewbuttonClick: navigateToProductUsageHistory,
                })}
              {...((isPlanActiveAndNotCancel || isFreemiumOrSelfServeUser) &&
                !isGuestUser() &&
                !hideNewPlans && {
                  buttonTitle: 'View add-ons',
                  buttonClick: isFreemiumOrSelfServeUser
                    ? () => setModifySubscription?.(true)
                    : navigateToAddOns,
                })}
                isImagineCreditModal
                >
              <div className="w-100">
                <Row className="gx-3 plan-limit-row">
                  {_includedInPlans.map((data, i) => {
                    return (
                      <Col xxl={4} lg={6} xs={12} key={data?.product_id}>
                        <PlanLimitCard
                          list={_includedInPlans}
                          data={data}
                          modalValue={filterModalDetails()}
                          totalCount={_includedInPlans?.length}
                          keyId={data?.product_id}
                          setSelectedCardProductId={setSelectedCardProductId}
                          selectedCardProductId={selectedCardProductId}
                          initialGetCountAPI={initialGetCountAPI}
                          planName={planName}
                        />
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </Wrapper>
          </Wrapper>
        )}
        {_addonsLimit?.length > 0 ? (
          <Wrapper
            className={`mb-4 ${isFreemiumOrSelfServeUser ? styles.availableAddonsDesignV2 : ''}`}>
            {loading ||
              (loader && (
                <Loader position="absolute" style={{ backgroundColor: '#fff' }} loading backdrop />
              ))}
            <Wrapper
              title="Additional upgrades purchased"
              className={styles.addonsContainer}
              childrenClassName={'gap-3'}
              {...((isPlanActiveAndNotCancel || isFreemiumOrSelfServeUser) &&
                !isGuestUser() &&
                !hideNewPlans && {
                  buttonTitle: 'View add-ons',
                  buttonClick: isFreemiumOrSelfServeUser
                    ? () => setModifySubscription?.(true)
                    : navigateToAddOns,
                })}>
              <div className="w-100">
                <Row className="gx-3 plan-limit-row">
                  {_addonsLimit?.length > 0 ? (
                    _addonsLimit.map((data, i) => {
                      return (
                        <Col xxl={4} lg={6} xs={12} key={data?.product_id}>
                          <PlanLimitCard
                            list={_addonsLimit}
                            data={data}
                            modalValue={filterModalDetails()}
                            totalCount={
                              unlimitedRenderingPackRef?.current
                                ? _addonsLimit?.length - 1
                                : _addonsLimit?.length
                            }
                            keyId={data?.product_id}
                            setSelectedCardProductId={setSelectedCardProductId}
                            selectedCardProductId={selectedCardProductId}
                            initialGetCountAPI={initialGetCountAPI}
                            planName={planName}
                          />
                        </Col>
                      );
                    })
                  ) : (
                    <>
                      {!hideNewPlans && (
                        <div className={styles.noAddonsContainer}>
                          <p>
                            You can always add more items to your plan. Click on the button below
                          </p>
                          <p>to check what all items can be added for your products.</p>
                          <span>
                            <BigButton
                              variant="warning"
                              onClick={() =>
                                isFreemiumOrSelfServeUser
                                  ? setModifySubscription?.(true)
                                  : navigateToAddOns
                              }>
                              View add-ons
                            </BigButton>
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </Row>
              </div>
            </Wrapper>
          </Wrapper>
        ) : (
          <>
            {isPremiumAndSelfServePlan && !isFreemiumUser && (
              <AddOnsInfoV2
                setModifySubscription={setModifySubscription}
                showSeparateList={false}
                removeMarginTop
              />
            )}
          </>
        )}
      </>
    );
  }

 let updatedFilterCounts = filterCounts?.slice()

if (imagineCreditLimit?.length > 0) {
  imagineCreditLimit.forEach((creditLimit) => {
    updatedFilterCounts.push({
      name: creditLimit?.basemodeltype || 'Imagine Credits',
      pack_productid: null,
      pack_product_name: null,
      is_add_on: true,
      is_one_time: true,
      is_pack_product: false,
      is_manually: true,
      is_freemium: true,
      total_count: +creditLimit?.total_limit,
      used_count: formatNumber(+creditLimit?.total_limit - +creditLimit?.available_limit),
      available_count: +creditLimit?.available_limit,
      subscription_id: null,
      product_id: null,
      basemodeltype: creditLimit?.basemodeltype || 'Imagine Credits',
      is_upload_limit_plan: null,
    });
  });
}

  return (
    <Wrapper className="mb-4">
      {loading ||
        (loader && (
          <Loader position="absolute" style={{ backgroundColor: '#fff' }} loading backdrop />
        ))}
      <Wrapper
        title="Your Imagine Products"
        // showTooltip={
        //   showTooltip && {
        //     icon: InfoIcon,
        //     message: 'Your plan might include one-time items from before.',
        //   }
        // }
        className="p-4"
        childrenClassName={'gap-3'}
        {...((showProductUsageHistoryButton ||
          isPlanActiveAndNotCancel ||
          isFreemiumOrSelfServeUser ||
          isPremiumUser()) &&
          !isGuestUser() && {
            productUsageViewTitle: 'View usage history',
            productUsageViewbuttonClick: navigateToProductUsageHistory,
          })}
        {...((isPlanActiveAndNotCancel || isFreemiumOrSelfServeUser) &&
          !isGuestUser() &&
          !hideNewPlans && {
            buttonTitle: 'View add-ons',
            buttonClick: isFreemiumOrSelfServeUser
              ? () => setModifySubscription?.(true)
              : navigateToAddOns,
          })}
        style={{
          background: '#fff',
          border: 'none',
          borderBottom: '1px solid #e8e8e8',
          borderRadius: 0,
        }}
        isImagineCreditModal
        >
        <div className="w-100">
          <Row className="gx-3 plan-limit-row">
            {updatedFilterCounts?.map((data, i) => {
              return (
                <Col xxl={4} lg={6} xs={12} key={data?.product_id}>
                  <PlanLimitCard
                    list={filterCounts}
                    data={data}
                    modalValue={filterModalDetails()}
                    totalCount={
                      unlimitedRenderingPackRef?.current
                        ? filterCounts?.length - 1
                        : filterCounts?.length
                    }
                    keyId={data?.product_id}
                    setSelectedCardProductId={setSelectedCardProductId}
                    selectedCardProductId={selectedCardProductId}
                    initialGetCountAPI={initialGetCountAPI}
                    planName={planName}
                  />
                </Col>
              );
            })}
          </Row>
        </div>
      </Wrapper>
    </Wrapper>
  );
};

export const PlanLimitCard = ({
  list = [],
  data,
  keyId,
  selectedCardProductId,
  totalCount,
  setSelectedCardProductId,
  modalValue,
  planName = '',
  initialGetCountAPI = () => {},
}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [modal, setModal] = useState(false);
  const [buyLoader, setBuyLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [cancelRequestLoader, setCancelRequestLoader] = useState(false);
  const [editAddons, setEditAddons] = useState(null);
  const purchaseAddOnsList = useSelector(selectPurchaseAddOns);
  const is3DModalCardActive = useSelector(selectIsThreeDCardActive);
  const { results: addonsList } = useSelector(selectAddonsList);
  const { results } = purchaseAddOnsList || {};
  const { isGuestUser } = useUserContext();
  const { isFreemiumOrSelfServeUser, isFreemiumUser, hideNewPlans } = useCurrentOrganizationInfo();
  const userPlans = useSelector(selectUserPlanList);

  useEffect(() => {
    return () => {
      dispatch(subscriptionActions.setThreeDCardActive(true));
    };
  }, []);

  useEffect(() => {
    const findModalData = list?.find(
      ({ basemodeltype }) => basemodeltype === THREE_D_MODEL_VARIATION_PRODUCT_NAME
    );
    if (is3DModalCardActive) {
      dispatch(
        subscriptionActions.setThreeDCardActive(
          !(findModalData && +findModalData?.total_count > 0 && +findModalData?.total_count < 2)
        )
      );
    }
  }, [list]);

  let cloneData = { ...data },
    cloneModalValue = { ...modalValue };

  const convertDataInto3DModal = (value, isModalValue) => {
    if (isModalValue) {
      // value.name = '3D Model';
      // value.product_id = PRODUCT_ID_ONE;
      value.total_count = Math.floor(value?.total_count / 2);
      value.used_count = Math.floor(value?.used_count / 2);
      value.available_count = Math.floor(value?.available_count / 2);
      if (value?.itemsFrom?.length) {
        value.itemsFrom = value?.itemsFrom?.map((list) => {
          return {
            ...list,
            qty: Math.floor(list.qty / 2),
          };
        });
      }
    } else {
      value.is_add_on = true;
      value.is_one_time = true;
      value.is_manually = false;
      value.is_freemium = false;
      value.total_count = Math.floor(value?.total_count / 2);
      value.used_count = Math.floor(value?.used_count / 2);
      value.available_count = Math.floor(value?.available_count / 2);
    }
    return value;
  };
  data =
    cloneData?.basemodeltype === THREE_D_MODEL_VARIATION_PRODUCT_NAME && is3DModalCardActive
      ? convertDataInto3DModal(cloneData)
      : cloneData;

  modalValue =
    cloneModalValue?.basemodeltype === THREE_D_MODEL_VARIATION_PRODUCT_NAME && is3DModalCardActive
      ? convertDataInto3DModal(cloneModalValue, true)
      : cloneModalValue;

  const addDataToSegment = (str) => {
    const dataForSegment = {
      Current_Plan_Name: planName,
      Card_Clicked: modalValue?.basemodeltype || '',
    };
    if (str === 'cardClick') {
      callTrackEvent('My Plan card Details', dataForSegment, true);
    } else {
      (dataForSegment['Total_Limit'] = modalValue?.total_count),
        (dataForSegment['Used_Limit'] = modalValue?.used_count),
        (dataForSegment['Remaining_Limit'] = modalValue?.available_count),
        (dataForSegment['Subscription_plan'] = modalValue?.itemsFrom?.[0]?.name);
      callTrackEvent('My Plan card Details buy more click', dataForSegment, true);
    }
  };

  const handleToggle = () => {
    setShow(!show);
    if (!show) {
      addDataToSegment('cardClick');
    }
    setSelectedCardProductId(!show === false ? null : keyId);
    editAddons && setEditAddons(null);
  };

  const getAddOnsPlans = async () => {
    await dispatch(GetPurchasedOnAddonsList());
  };

  const buyProduct = async (qty, interval) => {
    const product = modalValue?.product_id ? modalValue : data;

    removeParamsFromUrl({
      removeAll: true,
      skipParams: ['activeTab'],
    });

    if (product?.basemodeltype === ADD_ONS_PRODUCT_BASE_NAME?.AIImages) {
      // navigate(PRICING_ROUTE);
      navigate(MY_PLANS_ROUTE);
      return;
    }
    if (product?.basemodeltype === ADD_ONS_PRODUCT_BASE_NAME?.ImagineCredits) {
      openFormInCaseOfNewOrgAndFreemiumUser();
      return;
    }
    addDataToSegment();
    if (
      isFreemiumOrSelfServeUser &&
      [ADD_ONS_PRODUCT_BASE_NAME.Texture, ADD_ONS_PRODUCT_BASE_NAME.Model3DUploadLimit].includes(
        product?.basemodeltype
      )
    ) {
      setBuyLoader(true);
      await dispatcher(GetAllCartProductList());
      await removeAllItemsFromCart();
      setBuyLoader(false);
      // when user have the upload limit plan then this logic we used to checkout texture or modal plan
      let tab = SETTINGS_TAB.ADD_ONS;
      if (isFreemiumOrSelfServeUser) {
        tab = SETTINGS_TAB.PLANS;
      }
      navigate(
        `${ADMIN_SETTINGS}?activeTab=${tab}&${UPLOAD_LIMIT_TYPE_LABEL}=${product?.basemodeltype}&referrer=${window.location.href}`
      );
      return;
    }

    let is3dModel = false;
    if (product?.basemodeltype === THREE_D_MODEL_VARIATION_PRODUCT_NAME && is3DModalCardActive) {
      is3dModel = addonsList?.find(
        ({ basemodeltype }) => basemodeltype === THREE_D_MODEL_PRODUCT_NAME
      );
    }

    const addonsItem =
      is3dModel ||
      addonsList?.find(({ basemodeltype, name, is_one_time }) =>
        basemodeltype?.toLowerCase() === 'images'
          ? name?.toLowerCase()?.includes(product?.name?.toLowerCase())
          : basemodeltype === product?.basemodeltype && is_one_time === product?.is_one_time
      ) || addonsList?.find(({ basemodeltype, name }) =>
        basemodeltype?.toLowerCase() === 'images'
          ? name?.toLowerCase()?.includes(product?.name?.toLowerCase())
          : basemodeltype === product?.basemodeltype)
     // Sometimes, the subscription price ID does not match because it is from the current add-ons list, so we take the latest ID from the list.
     const subscriptionPriceId = addonsList?.find(({basemodeltype, prices})=> (prices?.length && basemodeltype === addonsItem?.basemodeltype))?.id || null
     
     if (addonsItem?.id || product?.product_id || subscriptionPriceId) {
      !qty ? setBuyLoader(true) : setSaveLoader(true);
      await dispatcher(GetAllCartProductList());
      let payload = {
        subscription_price: subscriptionPriceId || addonsItem?.id || product.product_id,
        quantity: qty || 1,
      };
      await removeAllItemsFromCart();
      const response = await AddAddonCart(payload, 'add');
      await dispatcher(GetAllCartProductList());

      if (!addonsItem?.id) {
        dispatch(subscriptionActions.setHubspotItem({ quantity: qty || 1, ...product }));
      }

      if (response?.status) {
        let tab = SETTINGS_TAB.ADD_ONS;
        if (isFreemiumOrSelfServeUser) {
          tab = SETTINGS_TAB.PLANS;
        }

        navigate(
          `${ADMIN_SETTINGS}?activeTab=${tab}&checkout=true&is_one_time=${
            addonsItem?.id ? addonsItem?.is_one_time : product?.is_one_time
          }&interval=${interval || 1}&referrer=${window.location.href}`
        );
      }
      setTimeout(() => {
        setBuyLoader(false);
        setSaveLoader(false);
        handleToggle();
      }, 1000);
    }
  };

  const handleUpdateQuantity = ({ increase }) => {
    let cloneData = { ...editAddons };
    if (increase) {
      cloneData.childItem.qty = (+cloneData.childItem.qty || 0) + 1;
    } else {
      cloneData.childItem.qty =
        +cloneData.childItem.qty > 0 ? +cloneData.childItem.qty - 1 : +cloneData.childItem.qty;
    }
    setEditAddons(cloneData);
  };

  const handleSave = (oldData, modalSave) => {
    const qtyVal = oldData?.isEdit
      ? handleShowInfoMsg(oldData, modalValue, true)
      : oldData?.qty || 0;

    let count = +editAddons?.childItem?.qty - +qtyVal;
    if (+count === 0) {
      setEditAddons(null);
      return;
    }
    let plus = +editAddons?.childItem?.qty > +qtyVal ? true : false;
    if (plus) {
      const record = results?.find(({ id }) => +oldData?.subscription_id === +id);
      dispatch(subscriptionActions.SetAddOnsQtyIntervalViaSave(record?.recurring_interval));
      dispatch(
        subscriptionActions.SetAddOnsQtyIntervalCountViaSave(record?.recurring_interval_count)
      );
      buyProduct(count, oldData?.interval);
    } else {
      const filterValue = {
        count: Math.abs(count),
        plus,
        oldQTY: qtyVal,
        currentCount: Math.abs(+qtyVal) - Math.abs(+editAddons?.childItem?.qty),
        data: oldData,
      };
      setModal(filterValue);
    }
  };

  const handleRemoveQTY = async (value) => {
    let addonsDetails = null,
      planIdInfo = null;

    let _results = results;
    if (isFreemiumOrSelfServeUser) {
      _results = userPlans;
    }
    // In some cases, the old organization has an existing old plan running, but they purchase a new plan.
    // so we take subscription data base on selected item subscription.
    if (value?.data?.subscription_id) {
      if (results?.find(({ id }) => +id === +value?.data?.subscription_id)) {
        _results = results;
      } else {
        _results = userPlans;
      }
    }

    _results?.map(({ id, plan_details }) => {
      if (!addonsDetails) {
        addonsDetails = plan_details.find(
          (info) =>
            info?.basemodeltype === value?.data?.basemodeltype &&
            +info?.recurring_interval_id === +value?.data?.interval
        );
        if (addonsDetails) {
          planIdInfo = id;
        }
      }
    });
    if (addonsDetails?.product_quantity === 0) {
      addonsDetails = null;
    }
    // In some cases, the old organization has an existing old plan running, but they purchase a new plan.
    // In such cases, we remove the old UI.
    // If the user doesn't get the record, we check again using the add-on subscription data to retrieve the required data.

    if (!addonsDetails) {
      results?.map(({ id, plan_details }) => {
        if (!addonsDetails) {
          addonsDetails = plan_details.find(
            (info) =>
              info?.basemodeltype === value?.data?.basemodeltype &&
              +info?.recurring_interval_id === +value?.data?.interval
          );
          if (addonsDetails) {
            planIdInfo = id;
          }
        }
      });
    }
    const planId = planIdInfo;
    if (planId && addonsDetails) {
      let payload = {
        add_subscription_items: false,
      };
      if (isFreemiumOrSelfServeUser) {
        // const currentCount = Math.abs(modal?.count) - Math.abs(+modal?.oldQTY);
        payload.data = [
          {
            remove_item_id: addonsDetails?.price_stripe_price_id,
            remove_item_quantity: modal?.count, // passing the reduced quantity
          },
        ];
      } else {
        const currentCount = Math.abs(+modal?.oldQTY) - Math.abs(modal?.count);
        payload.remove_item_id = addonsDetails?.price_stripe_price_id;
        payload.remove_item_quantity = currentCount;
      }

      setSaveLoader(true);
      const api = isFreemiumOrSelfServeUser
        ? RemoveAddonsSubscriptionItemV2
        : RemoveAddonsSubscriptionItem;
      const res = await dispatch(api(payload, planId));
      setSaveLoader(false);
      if (res) {
        getAddOnsPlans();
        setEditAddons(null);
        initialGetCountAPI();
        dispatch(setClientSubscriptionPlans()); // calling this function to update the remaining & removed quantity ( for self serve user )
      }
    } else {
      errorToast('Something went wrong. Please try again!');
    }
  };

  const handleShowInfoMsg = (item, modalValue, returnCount, showInUI, editIcon) => {
    let _results = results;
    if (isFreemiumOrSelfServeUser) {
      _results = userPlans;
    }

    let record = _results?.find(({ id }) => +item?.subscription_id === +id);
    // In some cases, the old organization has an existing plan running, but they purchase a new plan.
    // In such cases, we remove the old UI.
    // If the user doesn't get the record, we check again using the add-on subscription data to retrieve the required data.

    if (!record) {
      record = results?.find(({ id }) => +item?.subscription_id === +id);
    }
    const addonsDetails =
      record?.plan_details
        ?.filter(({ basemodeltype }) => basemodeltype === item?.basemodeltype)
        ?.reduce((a, c) => {
          if (a?.basemodeltype === c?.basemodeltype) {
            // const itemsCount = a?.plan_id !== c?.plan_id ?
            //   {
            //     item_counts:
            //     {
            //       total_count: a.item_counts.total_count + c.item_counts.total_count,
            //       used_count: a.item_counts.used_count + c.item_counts.used_count,
            //       available_count: a.item_counts.available_count + c.item_counts.available_count
            //     }
            //   } : {}
            return {
              ...a,
              // ...itemsCount,
              product_quantity: a.product_quantity + c.product_quantity,
              to_remove_product_quantity:
                a.to_remove_product_quantity + c.to_remove_product_quantity,
            };
          }
          return c;
        }, {}) || [];
    const showData = +addonsDetails?.to_remove_product_quantity > 0 ? true : false;
    const removeItemQTY = addonsDetails?.to_remove_product_quantity;
    const productItemQTY = addonsDetails?.product_quantity;
    const expiredDate = getDateFromTimestamp(record?.current_period_end_timestamp, true);
    const itemCount = addonsDetails?.item_counts?.total_count;
    const bundleSize = parseInt(itemCount / ((+productItemQTY || 0) + (+removeItemQTY || 0)));

    // when MATTRESS_BUILDER_BASE_TYPE item and remove qty has and edit icons means it UI so directly show zero
    if (
      editIcon &&
      item?.basemodeltype === MATTRESS_BUILDER_BASE_TYPE &&
      removeItemQTY &&
      !productItemQTY
    ) {
      return 0;
    }
    if (returnCount && !editIcon) return productItemQTY;

    if (returnCount && (productItemQTY || removeItemQTY)) {
      return (
        <>
          {editIcon && !isGuestUser() ? editIcon : null}
          {bundleSize > 1 && +productItemQTY > 0
            ? `${productItemQTY} * ${bundleSize} = ${productItemQTY * bundleSize}`
            : productItemQTY}{' '}
          {!isFreemiumOrSelfServeUser && +removeItemQTY > 0 ? (
            <>
              <br></br>
              <span
                style={{
                  color: 'black',
                  fontSize: '16px',
                  marginRight: '0',
                }}>{`${+bundleSize > 1 ? `${removeItemQTY} * ${bundleSize} = ` : ''} ${
                +removeItemQTY * bundleSize
              }`}</span>
            </>
          ) : (
            ''
          )}
        </>
      );
    }
    if (!showData || !item?.isEdit) {
      return null;
    }
    return (
      <p
        style={{
          color: 'var(--error-color)',
          fontSize: '0.75rem',
          fontWeight: 400,
          marginBottom: '0px',
          marginTop: '5px',
        }}>
        {`You have ${removeItemQTY} more item that will expire on ${expiredDate}`}
        <span className={`${styles.cursor}`}>
          <InfoIcon
            onClick={() =>
              showRemovedAddOnsInfo(removeItemQTY, +record?.current_period_end_timestamp)
            }
          />
        </span>
      </p>
    );
  };

  const closeDialog = () => {
    setModal(false);
  };

  const showRemovedAddOnsInfo = (qty = 0, date = null) => {
    if (qty === 0) return;
    const formattedDate = date ? ` (${getDateFromTimestamp(date, true)})` : '';
    openInfoDialog({
      title: 'Removed Add-Ons',
      description: `${
        +qty === 1 ? `There is ${qty} more unit` : `There are ${qty} more units`
      } available in your account till the current period end${formattedDate}. This change was made due to the removal of these units from your subscription by you.`,
      buttonText: 'Close',
    });
  };

  const removeAddOnsModal = () => {
    return (
      <SubscriptionStatusModal
        show={true}
        onClose={closeDialog}
        icon={modal?.plus ? PlusIcon : DeleteIcon}
        heading={modal?.plus ? 'Purchase Add-ons' : 'Remove Add-ons'}
        description={
          modal?.plus ? (
            <>
              Are you sure you want to purchase more <strong>{modal?.count}</strong>
              <strong>{editAddons?.parentItem.name}</strong>?
            </>
          ) : (
            <>
              Are you sure you want to remove <strong>{`${modal?.count} `}</strong>
              <strong>{editAddons?.parentItem.name}</strong>?
            </>
          )
        }
        actions={
          <>
            <div className="d-flex">
              <Button size={'xlg'} color={'secondary'} className="flex-fill" onClick={closeDialog}>
                Cancel
              </Button>
              <Button
                size={'xlg'}
                className="flex-fill ms-2"
                onClick={() => {
                  handleRemoveQTY(modal);
                  closeDialog();
                }}>
                Agree
              </Button>
            </div>
          </>
        }
      />
    );
  };

  const isUnlimitedCount = data?.basemodeltype === UNLIMITED_RENDERING;
  const isUnlimitedAIGenerate = data?.basemodeltype === UNLIMITED_AI_GENERATION;
  const isUnlimitedCreations = data?.basemodeltype === MATTRESS_BUILDER_BASE_TYPE;
  const isImagineCredit = HIDE_ARROW_TYPES
  .map(type => type?.toLowerCase()?.trim())
  .includes(data?.basemodeltype?.toLowerCase()?.trim());
  const currentIndex = list?.findIndex((item) => item?.product_id === selectedCardProductId);
  const activePlans =
    userPlans?.filter((plan) => !plan.is_cancelled && plan?.status !== 'deleted') || [];

  const handleCancelDowngradeRequest = async (data, subscriptionDetails) => {
    data = data?.filter(Boolean) || [];
    if (subscriptionDetails?.id && data?.length) {
      setCancelRequestLoader({ price: data?.[0], id: subscriptionDetails?.id });
      const payload = {
        cancel_downgrade: true,
        data: data,
      };
      const res = await UpgradeToNewPlanPatchV2(payload, subscriptionDetails?.id);
      setCancelRequestLoader(false);
      if (res) {
        successToast('Request canceled successfully.');
        dispatch(GetPurchasedOnAddonsList());
        dispatch(setClientSubscriptionPlansV2());
        dispatch(setFailedClientSubscriptionPlansAndAddOnsV2());
      }
      return res;
    } else {
      warningToast('Something went wrong. Please contact the admin.');
    }
  };

  const handleShowDynamicText = () => {
    if (isUnlimitedCreations) {
      return <span>Unlimited Creations.</span>;
    }

    if (isUnlimitedAIGenerate) {
      return <span>You can generate unlimited AI images.</span>;
    }

    if (isUnlimitedCount) {
      return <span>You can create unlimited images.</span>;
    }

    return `${data?.used_count || 0} used out of ${data?.total_count || 0}`;
  };

  return (
    <>
      <Card className={styles.planCard}>
        <div className={styles.planInfoHeader}>
          <div className={styles.planDescription}>
            {data?.basemodeltype !== THREE_D_MODEL_VARIATION_PRODUCT_NAME ? (
              data?.name === ADD_ONS_PRODUCT_BASE_NAME.Editor && data?.total_count > 1 ? (
                'EDITORS'
              ) : (
                data?.name
              )
            ) : (
              <>
                <span className="d-flex">
                  <span
                    className={`me-1 ${styles.cursor} ${is3DModalCardActive && styles.active}`}
                    onClick={() => dispatch(subscriptionActions.setThreeDCardActive(true))}>
                    3D Model
                  </span>
                  <span className="me-1">/</span>
                  <span
                    onClick={() => dispatch(subscriptionActions.setThreeDCardActive(false))}
                    className={`${styles.cursor} ${!is3DModalCardActive && styles.active}`}>
                    {data?.name}
                  </span>
                  <ElipsisTooltip
                    title={'Click on title to switch between 3D model variation and 3D model.'}
                    alwaysShow={true}>
                    {(props) => (
                      <div style={{ cursor: 'pointer', width: 24, height: 24 }} {...props}>
                        <InfoIcon />
                      </div>
                    )}
                  </ElipsisTooltip>
                </span>
              </>
            )}
            {/* <span>
              <InfoIcon />
            </span> */}
          </div>
          {!isUnlimitedCount && !isUnlimitedAIGenerate && !isImagineCredit ? (
            <div className="ms-auto" onClick={handleToggle}>
              <RightIcon />
            </div>
          ) : null}
        </div>
        <div className={styles.cardContent}>
          {!isFreemiumOrSelfServeUser &&
            progressSliderType(getPercentValueFromCount(data?.total_count, data?.used_count)) ===
              'danger' && (
              <>
                <div className={styles.cardAction}>
                  <p>
                    <InfoIcon /> <span>You’re running out on item</span>
                  </p>
                  {!isGuestUser() ? (
                    <BigButton
                      variant="warning"
                      disabled={buyLoader}
                      isLoading={buyLoader}
                      onClick={buyProduct}>
                      Buy more
                    </BigButton>
                  ) : null}
                </div>
              </>
            )}
          <div className={styles.cardInfo}>
            <h4 className={'mb-3'}>{handleShowDynamicText()}</h4>
            <ProgressBar
              variant={progressSliderType(
                isUnlimitedCount || isUnlimitedAIGenerate || isUnlimitedCreations
                  ? 0
                  : getPercentValueFromCount(data?.total_count, data?.used_count)
              )}
              now={
                isUnlimitedCount || isUnlimitedAIGenerate || isUnlimitedCreations
                  ? 100
                  : getPercentValueFromCount(data?.total_count, data?.used_count)
              }
            />
          </div>
        </div>
      </Card>
      <>
        {modal && removeAddOnsModal()}
        {show && (
          <ModalButtonArea
            size="lg"
            startOpen={show}
            centered={true}
            variant="link"
            onClose={handleToggle}
            className="subscription-item-modal"
            backdropClassName="overlay-dark"
            headingLeft
            body={
              <>
                <div className={styles.modalArrow}>
                  {currentIndex > 0 ? (
                    <LeftArrowALT
                      onClick={() => {
                        setSelectedCardProductId(list?.[currentIndex - 1]?.product_id);
                        editAddons && setEditAddons(null);
                      }}
                    />
                  ) : (
                    <span></span>
                  )}
                  {currentIndex + 1 < +totalCount && (
                    <RightArrowALT
                      onClick={() => {
                        setSelectedCardProductId(list?.[currentIndex + 1]?.product_id);
                        editAddons && setEditAddons(null);
                      }}
                    />
                  )}
                </div>
                <h4>
                  {modalValue?.basemodeltype !== THREE_D_MODEL_VARIATION_PRODUCT_NAME ? (
                    modalValue?.name === ADD_ONS_PRODUCT_BASE_NAME.Editor &&
                    modalValue?.total_count > 1 ? (
                      'Editors'
                    ) : (
                      modalValue?.name
                    )
                  ) : (
                    <>
                      <span className="d-flex">
                        <span
                          className={`me-1 ${styles.cursor} ${
                            is3DModalCardActive && styles.active
                          }`}
                          onClick={() => dispatch(subscriptionActions.setThreeDCardActive(true))}>
                          3D Model
                        </span>
                        <span className="me-1">/</span>
                        <span
                          onClick={() => dispatch(subscriptionActions.setThreeDCardActive(false))}
                          className={`${styles.cursor} ${!is3DModalCardActive && styles.active}`}>
                          {modalValue?.name}
                        </span>
                      </span>
                    </>
                  )}
                </h4>
                {modalValue?.basemodeltype === THREE_D_MODEL_VARIATION_PRODUCT_NAME &&
                  is3DModalCardActive && (
                    <p>Your 3D model variation count is 2 times your 3D models.</p>
                  )}
                {modalValue?.basemodeltype === MATTRESS_BUILDER_BASE_TYPE ? (
                  <p>
                    {`Your Mattress Builder subscription is active, allowing you to create unlimited
                    mattresses, customize them in 3D, and visualize your designs, all included in
                    your ${
                      modalValue?.itemsFrom[0]?.name?.toLowerCase?.() || 'monthly/yearly'
                    } plan`}
                  </p>
                ) : (
                  <ul className={styles.quantityStats}>
                    <li>
                      <p>Total</p>
                      <h4>{modalValue?.total_count}</h4>
                    </li>
                    <li>
                      <p>Used</p>
                      <h4>{modalValue?.used_count}</h4>
                    </li>
                    <li>
                      <p>Remaining</p>
                      <h4>{modalValue?.available_count}</h4>
                    </li>
                  </ul>
                )}
                <Table className={styles.subscriptionTable}>
                  <thead>
                    <tr>
                      <th>Item added from</th>
                      <th className="pe-0">Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalValue?.itemsFrom?.length > 0 &&
                      SortArrayBySeq(modalValue?.itemsFrom, 'seq').map((item, index) => {
                        const editIcon = (
                          <span
                            // className={
                            //   !item?.isEdit ? `${styles.iconSpace} ${styles.cursor}` : styles.cursor
                            // }>
                            className={`${styles.iconSpace} ${styles.cursor} pe-0`}>
                            {' '}
                            {!item?.isEdit ? (
                              ''
                            ) : !isGuestUser() && !item?.isMattressBuilder ? (
                              <EditPensilIcon
                                color="#EC4E0B"
                                onClick={() =>
                                  setEditAddons({
                                    parentItem: { ...modalValue },
                                    childItem: {
                                      ...item,
                                      qty: Math.abs(handleShowInfoMsg(item, modalValue, true)),
                                    },
                                    index: index,
                                  })
                                }
                              />
                            ) : null}
                          </span>
                        );
                        return (
                          <tr key={index}>
                            <td>
                              <span className="d-flex">
                                {item?.name}
                                {item?.tooltip && (
                                  <ElipsisTooltip title={item?.tooltip} alwaysShow={true}>
                                    {(props) => (
                                      <div
                                        style={{ cursor: 'pointer', width: 24, height: 24 }}
                                        {...props}>
                                        <InfoIcon />
                                      </div>
                                    )}
                                  </ElipsisTooltip>
                                )}
                              </span>
                              {!isFreemiumOrSelfServeUser &&
                                !modalValue?.basemodeltype === MATTRESS_BUILDER_BASE_TYPE &&
                                handleShowInfoMsg(item, modalValue)}
                            </td>
                            <td
                              className={
                                item?.isMattressBuilder
                                  ? 'd-flex align-items-center justify-content-end'
                                  : ''
                              }>
                              {!item?.isMattressBuilder &&
                              editAddons &&
                              editAddons?.childItem?.id === item?.id ? (
                                <>
                                  {' '}
                                  <div className="d-flex align-items-center justify-content-end">
                                    <Button
                                      loading={saveLoader}
                                      className={`${styles.selectionButton} cursor-pointer add-to-cart-btn`}>
                                      <input
                                        type="number"
                                        onChange={(e) => e.preventDefault()}
                                        value={editAddons?.childItem?.qty || 0}
                                      />
                                      <MinusIcon
                                        onClick={() =>
                                          handleUpdateQuantity({
                                            increase: false,
                                          })
                                        }
                                      />
                                      <PlusIcon
                                        onClick={() =>
                                          handleUpdateQuantity({
                                            increase: true,
                                          })
                                        }
                                      />
                                    </Button>
                                    <p
                                      className={`${styles.cursor} ms-3 pt-2`}
                                      onClick={() => handleSave(item, modalValue)}>
                                      Save
                                    </p>
                                    <p
                                      className={`${styles.cursor} ms-3 pt-2`}
                                      onClick={() => setEditAddons(null)}>
                                      Cancel
                                    </p>
                                  </div>
                                </>
                              ) : (
                                <>
                                  {item?.isEdit
                                    ? handleShowInfoMsg(item, modalValue, true, true, editIcon)
                                    : item?.qty || 0}{' '}
                                  {/* {!item?.isEdit && editIcon} */}
                                </>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
                {modalValue?.itemsFrom?.[0]?.isMattressBuilder &&
                  Math.abs(handleShowInfoMsg(modalValue?.itemsFrom?.[0], modalValue, true)) > 0 && (
                    <div style={{ width: '100%', alignContent: 'center', justifyItems: 'center' }}>
                      <Button
                        size={'xlg'}
                        style={{
                          padding: '10px',
                          borderRadius: '5px',
                          height: '35px',
                          backgroundColor: '#E7E7E7',
                          color: '#141414',
                          border: '0px',
                          opacity: '1',
                          display: 'flex',
                        }}
                        onClick={() => {
                          setEditAddons({
                            parentItem: { ...modalValue },
                            childItem: {
                              ...modalValue?.itemsFrom?.[0],
                              qty: 1,
                            },
                            index: 0,
                          });
                          setModal({
                            count: 1,
                            plus: false,
                            oldQTY: 1,
                            currentCount: 0,
                            data: modalValue?.itemsFrom?.[0],
                          });
                        }}>
                        Cancel
                      </Button>
                    </div>
                  )}
                {!isGuestUser() && !hideNewPlans && 
                modalValue?.basemodeltype !==
                  UPLOAD_SUBSCRIPTION_TITLE_BASE_ON_BASE_TYPE['Unlimited AI Generation'] ? (
                  isFreemiumOrSelfServeUser &&
                  HIDE_BUY_MORE_FOR_SELF_SERVE_BASE_TYPE_LIST?.includes(
                    modalValue?.basemodeltype
                  ) ? null : MATTRESS_BUILDER_BASE_TYPE === modalValue?.basemodeltype ? null : (
                    <BigButton
                      className={styles.modalButton}
                      disabled={buyLoader}
                      isLoading={buyLoader}
                      onClick={buyProduct}>
                      Buy more
                    </BigButton>
                  )
                ) : null}
                {(isFreemiumOrSelfServeUser ||
                  modalValue?.basemodeltype === MATTRESS_BUILDER_BASE_TYPE) && (
                  <>
                    {modalValue?.itemsFrom?.length > 0 &&
                      SortArrayBySeq(modalValue?.itemsFrom, 'seq').map((item, index) => {
                        const removeQTY = +handleShowInfoMsg(item, modalValue, true, true, null);
                        const isItemRemoved = Boolean(handleShowInfoMsg(item, modalValue));

                        if (!isItemRemoved) return null;

                        let activePlan = activePlans?.find(
                          ({ recurring_interval, id }) =>
                            +id === +item?.subscription_id &&
                            +recurring_interval === +item?.interval
                        );

                        // In some cases, the old organization has an existing old plan running, but they purchase a new plan.
                        // In such cases, we remove the old UI.
                        // If the user doesn't get the record, we check again using the add-on subscription data to retrieve the required data.
                        if (!activePlan) {
                          activePlan =
                            results?.find(({ id }) => +id === +item?.subscription_id) ||
                            results?.find(({ plan_details }) =>
                              plan_details?.find(
                                ({ basemodeltype }) => basemodeltype === item?.basemodeltype
                              )
                            );
                        }
                        const subscriptionEndDate = getDateFromTimestamp(
                          activePlan?.current_period_end_timestamp,
                          true
                        );
                        const priceDetails = activePlan?.plan_details?.find(
                          ({ basemodeltype }) => basemodeltype === item?.basemodeltype
                        );
                        const allItemCanceled = isItemRemoved && +removeQTY === 0;
                        return (
                          <>
                            <div className={styles.bannerSection}>
                              {allItemCanceled ? (
                                <p>
                                  <span className="me-1">
                                    <WarningInfoIcon />
                                  </span>
                                  {`Your ${item?.basemodeltype || ''} ${
                                    item?.name
                                  } limit are set to be cancelled, You will have access to ${+item?.qty} ${
                                    item?.basemodeltype
                                  } ${item?.name} until ${subscriptionEndDate}.`}
                                </p>
                              ) : (
                                <p>
                                  <span className="me-1">
                                    <WarningInfoIcon />
                                  </span>
                                  {`Your account has been downgraded to ${+item?.qty - removeQTY} ${
                                    item?.basemodeltype || ''
                                  } ${
                                    item?.name
                                  } limit. This change will take effect on ${subscriptionEndDate}.`}
                                </p>
                              )}
                              <span
                                onClick={() =>
                                  handleCancelDowngradeRequest(
                                    [priceDetails?.price_stripe_price_id],
                                    activePlan
                                  )
                                }>
                                {cancelRequestLoader?.price ===
                                  priceDetails?.price_stripe_price_id &&
                                +activePlan?.id === +cancelRequestLoader?.id ? (
                                  <CircularProgress size={18} thickness={2} />
                                ) : (
                                  'Cancel Request'
                                )}
                              </span>
                            </div>
                          </>
                        );
                      })}
                  </>
                )}
              </>
            }
          />
        )}
      </>
    </>
  );
};
